(function () {
    'use strict';
  
    const UG_MF_MOBILE_MQ = '(max-width: 1023.98px)';
    const UG_MF_SCROLL_MANUAL_PC = 1200;
    const UG_MF_SCROLL_MANUAL_MB = 760;
    const UG_MF_AUTO_DUR = 1.15;
    const UG_MF_AUTO_EASE = 'power2.inOut';
    const UG_MF_SCROLL_DUR = 1.25;
    const UG_MF_SCROLL_STAGGER = 0.08;
    const UG_MF_SCROLL_DIST_RATIO_CAP = 2;
    const UG_MF_LAYER_START_SCALE = [1.012, 1.022, 1.032, 1.04];
    const UG_MF_SCRUB = 0.55;
    /** 无 data-*-mb 时按 PC 比例换算的兜底 */
    const UG_MF_MB_TOP_SCALE = 555 / 883;
    const UG_MF_PD_SCALE_START_PC = 0.52;
    const UG_MF_PD_SCALE_END_PC = 1;
    const UG_MF_PD_SCALE_START_MB = 0.48;
    const UG_MF_PD_SCALE_END_MB = 1;
    const UG_MF_PD_SCROLL_PC = 1100;
    const UG_MF_PD_SCROLL_MB = 720;
    const UG_MF_PD_SCRUB = 2;
    const UG_MF_GA_PRODUCT_DUR = 0.9;
    const UG_MF_PARTNERSHIP_CAROUSEL_AUTOPLAY_MS = 5000;
  
    let ugMfGsapRegistered = false;
    let ugMfCachedMobile = null;
    const UG_MF_BANNER_DEBUG_FORCE = false;
  
    function ugMfBannerDebugEnabled() {
      try {
        if (window['ugMfBannerDebug'] === true) return true;
        const qs = new URLSearchParams(window.location.search);
        if (qs.get('ugMfBannerDebug') === '1') {
          window.localStorage.setItem('ugMfBannerDebug', '1');
          return true;
        }
        if (qs.get('ugMfBannerDebug') === '0') {
          window.localStorage.removeItem('ugMfBannerDebug');
          return false;
        }
        if (UG_MF_BANNER_DEBUG_FORCE) return true;
        return window.localStorage.getItem('ugMfBannerDebug') === '1';
      } catch (e) {
        return false;
      }
    }
  
    function ugMfGetBannerDebugState(root) {
      const st = root && root._ugMfBannerScrollTrigger;
      const tl = root && root._ugMfBannerTimeline;
      const reverse = root && root._ugMfBannerReverse;
      const restoreProgress = reverse ? ugMfGetSkipAutoReverseVisualProgress(root) : null;
      const pin = root && (root._ugMfBannerPin || root.querySelector('[data-mf-banner-pin]'));
      const stage = root && (root._ugMfBannerStage || root.querySelector('[data-mf-banner-stage]'));
      const firstLayer = pin && pin.querySelector('[data-mf-layer]');
      const copy = pin && pin.querySelector('[data-mf-banner-copy]');
      const spacer = pin && pin.parentElement && pin.parentElement.classList.contains('pin-spacer')
        ? pin.parentElement
        : st && st.spacer;
  
      return {
        scrollY: Math.round(window.scrollY || 0),
        mode: root && root._ugMfBannerLayoutMode,
        autoDone: !!(root && root._ugMfBannerAutoDone),
        autoPlaying: !!(root && root._ugMfBannerAutoPlaying),
        skipAuto: !!(root && root._ugMfBannerSkipAuto),
        stStart: st && typeof st.start === 'number' ? Math.round(st.start) : null,
        stEnd: st && typeof st.end === 'number' ? Math.round(st.end) : null,
        stProgress: st && typeof st.progress === 'number' ? Number(st.progress.toFixed(4)) : null,
        stActive: !!(st && st.isActive),
        tlProgress: tl && typeof tl.progress === 'function' ? Number(tl.progress().toFixed(4)) : null,
        reversePhase: reverse ? reverse.phase : null,
        reverseStartY: reverse && reverse.startY != null ? Math.round(reverse.startY) : null,
        reverseEndY: reverse && reverse.endY != null ? Math.round(reverse.endY) : null,
        reverseProgress: restoreProgress === null ? null : Number(restoreProgress.toFixed(4)),
        pinClass: pin ? pin.className : null,
        pinHeight: pin ? Math.round(pin.getBoundingClientRect().height) : null,
        spacerHeight: spacer ? Math.round(spacer.getBoundingClientRect().height) : null,
        spacerPaddingBottom: spacer ? window.getComputedStyle(spacer).paddingBottom : null,
        stageTransform: stage ? window.getComputedStyle(stage).transform : null,
        firstLayerTop: firstLayer ? window.getComputedStyle(firstLayer).top : null,
        copyOpacity: copy ? window.getComputedStyle(copy).opacity : null,
      };
    }
  
    function ugMfBannerDebug(root, label, extra, force) {
      if (!ugMfBannerDebugEnabled()) return;
      const now = Date.now();
      if (!force && root && root._ugMfBannerDebugLastAt && now - root._ugMfBannerDebugLastAt < 180) {
        return;
      }
      if (root) root._ugMfBannerDebugLastAt = now;
    }
  
    window['ugMfBannerDebugDump'] = function ugMfBannerDebugDump() {
      const root = document.querySelector('.ug-mf');
      const state = ugMfGetBannerDebugState(root);
      return state;
    };
  
    window['ugMfBannerDebugOn'] = function ugMfBannerDebugOn() {
      window['ugMfBannerDebug'] = true;
      try {
        window.localStorage.setItem('ugMfBannerDebug', '1');
      } catch (e) {
        /* ignore */
      }
      const state = window['ugMfBannerDebugDump']();
      return state;
    };
  
    window['ugMfBannerDebugOff'] = function ugMfBannerDebugOff() {
      window['ugMfBannerDebug'] = false;
      try {
        window.localStorage.removeItem('ugMfBannerDebug');
      } catch (e) {
        /* ignore */
      }
    };
  
    function ugMfParseNum(value, fallback) {
      const n = parseFloat(value);
      return Number.isNaN(n) ? fallback : n;
    }
  
    function ugMfIsReloadNavigation() {
      try {
        const nav =
          window.performance && window.performance.getEntriesByType
            ? /** @type {PerformanceNavigationTiming | undefined} */ (
                window.performance.getEntriesByType('navigation')[0]
              )
            : null;
        return Boolean(nav && nav.type === 'reload');
      } catch (e) {
        return false;
      }
    }
  
    function ugMfClearReloadScrollLock() {
      try {
        document.documentElement.classList.remove('ug-mf-reload-at-top');
        document.documentElement.style.removeProperty('overflow');
        if (document.body) {
          document.body.style.removeProperty('overflow');
        }
      } catch (e) {
        /* ignore */
      }
    }

    function ugMfClearBannerAutoTimers(root) {
      if (!root) return;
      if (root._ugMfBannerAutoRestoreTimer) {
        window.clearTimeout(root._ugMfBannerAutoRestoreTimer);
        root._ugMfBannerAutoRestoreTimer = null;
      }
      if (root._ugMfBannerAutoFailsafeTimer) {
        window.clearTimeout(root._ugMfBannerAutoFailsafeTimer);
        root._ugMfBannerAutoFailsafeTimer = null;
      }
    }

    /** 开场 auto 卡住时强制解锁页面滚动并进入手动 Banner 段 */
    function ugMfForceCompleteBannerAuto(root) {
      if (!root || (!root._ugMfBannerAutoPlaying && !root._ugMfBannerAutoRunning)) return false;

      const pin = root._ugMfBannerPin;
      const stage = root._ugMfBannerStage;
      const layers = root._ugMfBannerLayers;
      const bannerCopy = root._ugMfBannerCopy || [];

      ugMfClearBannerAutoTimers(root);

      if (root._ugMfBannerAutoTimeline) {
        root._ugMfBannerAutoTimeline.kill();
        root._ugMfBannerAutoTimeline = null;
      }

      ugMfLockViewportScroll(root, false);

      if (!pin || !stage || !layers || !layers.length) {
        return false;
      }

      if (!root._ugMfBannerAutoDone) {
        ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy);
      }

      return true;
    }
  
    function ugMfEnsureReloadAtTop() {
      if (!ugMfIsReloadNavigation()) return false;
  
      try {
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'auto';
        }
      } catch (e) {
        /* ignore */
      }
  
      return true;
    }
  
    function ugMfPrefersReducedMotion() {
      return (
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }
  
    function ugMfGetManualScrollRange() {
      return ugMfIsMobile() ? UG_MF_SCROLL_MANUAL_MB : UG_MF_SCROLL_MANUAL_PC;
    }

    /** 清除旧版脚本写入的内联变量，避免覆盖 CSS 的 --ug-mf-mu 等 */
    function ugMfClearStaleInlineThemeVars(root) {
      if (!root || !root.style) return;
      root.style.removeProperty('--ug-mf-mu');
      root.style.removeProperty('--ug-mf-banner-h-mb');
      root.style.removeProperty('--ug-mf-banner-visual-height');
    }
  
    function ugMfGetBannerScrollPad(pin) {
      if (!pin) return null;
      const next = pin.nextElementSibling;
      return next && next.matches('[data-mf-banner-scroll-pad]') ? next : null;
    }
  
    function ugMfSetBannerScrollPad(root, pin, heightPx) {
      const pad = ugMfGetBannerScrollPad(pin);
      if (!pad) return;
  
      const height = Math.max(0, Number(heightPx) || 0);
      if (height > 0) {
        pad.style.height = height + 'px';
        if (root) {
          root.classList.add('ug-mf--banner-scroll-pad-active');
          root.style.setProperty('--ug-mf-banner-scroll-pad', height + 'px');
        }
      } else {
        pad.style.removeProperty('height');
        if (root) {
          root.classList.remove('ug-mf--banner-scroll-pad-active');
          root.style.removeProperty('--ug-mf-banner-scroll-pad');
        }
      }
    }
  
    function ugMfGetBannerScrollZone(root) {
      return root ? root.querySelector('[data-mf-banner-scroll-zone]') : null;
    }
  
    /** pinSpacing 在 ST 挂载后即占 manualScroll 高度；auto 结束 idle 段用负 margin 把 post-banner 拉回 Banner 下 */
    function ugMfSyncBannerIdleLayout(root) {
      if (!root || !root._ugMfBannerAutoDone || root._ugMfBannerReverse) {
        if (root) root.classList.remove('ug-mf--banner-idle');
        return;
      }

      const st = root._ugMfBannerScrollTrigger;
      if (!st) {
        root.classList.remove('ug-mf--banner-idle');
        return;
      }

      const progress = typeof st.progress === 'number' ? st.progress : 0;
      const idle =
        !ugMfIsBannerScrollComplete(root) &&
        !root.classList.contains('ug-mf--banner-scroll-handoff') &&
        progress <= 0.001;
  
      root.classList.toggle('ug-mf--banner-idle', idle);
    }
  
    /** 2→3 手动滚动：dock 二级导航在 Banner 下方，隐藏其余 post-banner 模块 */
    function ugMfSyncBannerScrollPhase(root) {
      if (!root) return;
  
      const st = root._ugMfBannerScrollTrigger;
      const progress = st && typeof st.progress === 'number' ? st.progress : 0;
      const inProgress = !!(st && st.isActive && progress > 0.001);
  
      root.classList.toggle('ug-mf--banner-scroll-in-progress', inProgress);
      ugMfSyncBannerIdleLayout(root);
    }
  
    function ugMfClearBannerScrollPhase(root) {
      if (!root) return;
      root.classList.remove(
        'ug-mf--banner-scroll-in-progress',
        'ug-mf--banner-scroll-handoff'
      );
      ugMfSyncBannerIdleLayout(root);
      const zone = root._ugMfBannerScrollZone || ugMfGetBannerScrollZone(root);
      if (zone) {
        zone.classList.remove('is-zone-pinned');
      }
    }
  
    /** Banner 手动段结束：只切状态，不在 pin 释放瞬间 refresh，避免 end 抽动 */
    function ugMfHandoffBannerToContent(root) {
      if (!root) return;
  
      ugMfApplyBannerScrollProgress(root, 1);
      root.classList.remove('ug-mf--banner-scroll-in-progress', 'ug-mf--banner-idle');
      root.classList.add('ug-mf--banner-scroll-handoff', 'ug-mf--banner-scroll-done');
      ugMfSetBannerPinActive(root, false);
  
      requestAnimationFrame(() => {
        root.classList.remove('ug-mf--banner-scroll-handoff');
        ugMfSyncBannerScrollState(root);
        ugMfNotifyBannerScrollComplete(root);
      });
    }
  
    function ugMfSetBannerLayoutMode(root, isMobile) {
      if (!root) return;
      const mode = isMobile ? 'mb' : 'pc';
      root._ugMfBannerLayoutMode = mode;
      root.classList.toggle('ug-mf--banner-mb', isMobile);
      root.classList.toggle('ug-mf--banner-pc', !isMobile);
    }
  
    /** 旧版 pinSpacing 会在 pin 外包一层 .pin-spacer 并把高度撑到 555+760 */
    function ugMfCleanupBannerPinSpacer(pin) {
      if (!pin || !pin.parentElement) return;
      const wrapper = pin.parentElement;
      if (!wrapper.classList || !wrapper.classList.contains('pin-spacer')) return;
      const parent = wrapper.parentNode;
      if (!parent) return;
      parent.insertBefore(pin, wrapper);
      wrapper.remove();
      pin.style.removeProperty('height');
      pin.style.removeProperty('min-height');
    }
  
    function ugMfGetHeaderOffset(root) {
      const custom = root && root.getAttribute('data-subnav-sticky-top');
      if (custom !== null && custom !== '') {
        const parsed = parseFloat(custom);
        if (!Number.isNaN(parsed)) return parsed;
      }
      const header = document.getElementById('header-component');
      return header ? header.offsetHeight : 0;
    }
  
    function ugMfApplyStickyTop(root) {
      if (!root) return;
      root.style.setProperty('--ug-mf-sticky-top', ugMfGetHeaderOffset(root) + 'px');
    }
  
    function ugMfSyncMobileState() {
      ugMfCachedMobile =
        typeof window.matchMedia === 'function' &&
        window.matchMedia(UG_MF_MOBILE_MQ).matches;
    }
  
    function ugMfIsMobile() {
      if (ugMfCachedMobile === null) ugMfSyncMobileState();
      return ugMfCachedMobile;
    }
  
    function ugMfEnsureGsapRegistered() {
      if (ugMfGsapRegistered) return true;
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) {
        return false;
      }
      gsap.registerPlugin(ScrollTrigger);
      ugMfGsapRegistered = true;
      return true;
    }

    ugMfEnsureGsapRegistered();
  
    function ugMfDebounce(fn, wait) {
      let timer = null;
      return function debounced() {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          timer = null;
          fn();
        }, wait);
      };
    }
  
    function ugMfMarkLayoutDirty(root) {
      if (!root) return;
      root._ugMfSubnavTopsDirty = true;
      ugMfFindFooterEl.cached = null;
    }
  
    function ugMfIsBannerPinScrollActive(root) {
      if (!root) return false;
      if (root._ugMfBannerAutoPlaying) return true;
      const st = root._ugMfBannerScrollTrigger;
      if (!st || !root._ugMfBannerAutoDone) return false;
      if (root._ugMfBannerReverse && root._ugMfBannerReverse.phase !== 'done') return true;
      return !!(st.isActive && !ugMfIsBannerScrollComplete(root));
    }
  
    function ugMfCanMountScrollEffects(root) {
      if (!root) return false;
      if (!root.querySelector('[data-mf-banner-pin]')) return true;
      if (root._ugMfBannerReducedMotion && root._ugMfBannerStaticMb) return true;
      return ugMfIsBannerScrollComplete(root);
    }
  
    function ugMfNotifyBannerScrollComplete(root) {
      if (!root) return;
      ugMfInitAfterBannerReady(root);
      ugMfMarkLayoutDirty(root);
      ugMfSyncBannerScrollState(root);
      ugMfUpdateStickyBarVisibility(root);
      ugMfRefreshSubnavSpy(root);
      ugMfTryInitScrollEffects(root);
    }
  
    function ugMfDeferUntilBannerReady(root, run) {
      if (!root || typeof run !== 'function') return;
      if (ugMfCanMountScrollEffects(root)) {
        run();
        return;
      }
  
      if (!root._ugMfBannerDeferQueue) {
        root._ugMfBannerDeferQueue = [];
      }
      if (root._ugMfBannerDeferQueue.indexOf(run) === -1) {
        root._ugMfBannerDeferQueue.push(run);
      }
    }
  
    function ugMfFlushBannerDeferQueue(root) {
      if (!root || !root._ugMfBannerDeferQueue || !root._ugMfBannerDeferQueue.length) {
        return;
      }
      if (!ugMfCanMountScrollEffects(root)) return;
  
      const queue = root._ugMfBannerDeferQueue.slice();
      root._ugMfBannerDeferQueue = [];
      queue.forEach((run) => {
        try {
          run();
        } catch (e) {
          /* ignore */
        }
      });
    }
  
    function ugMfEnsureScrollSync(root) {
      if (!root || root._ugMfScrollSync) return;
  
      const run = () => {
        if (!root._ugMfBannerAutoPlaying && root._ugMfBannerAutoDone) {
          ugMfSyncBannerManualProgress(root);
        } else {
          ugMfSyncBannerScrollState(root);
        }
        if (!root._ugMfBannerAutoPlaying && root._ugMfSecondaryReady && !ugMfIsBannerPinScrollActive(root)) {
          ugMfUpdateStickyBarVisibility(root);
          ugMfSyncStickyBarFlow(root);
          ugMfRefreshSubnavSpy(root);
        }
      };
  
      root._ugMfScrollSync = ugMfRafThrottle(run);
      window.addEventListener('scroll', root._ugMfScrollSync, { passive: true });
      window.addEventListener('resize', root._ugMfScrollSync, { passive: true });
      run();
    }
  
    function ugMfKillScrollSync(root) {
      if (!root || !root._ugMfScrollSync) return;
      window.removeEventListener('scroll', root._ugMfScrollSync);
      window.removeEventListener('resize', root._ugMfScrollSync);
      root._ugMfScrollSync = null;
    }
  
    /** MB：与 CSS --ug-mf-mu (100vw/375) 一致 */
    function ugMfGetMbMuScale() {
      const w = window.innerWidth || document.documentElement.clientWidth || 375;
      return w / 375;
    }

    /** PC 中屏 1024–1440：与 CSS --ug-mf-u (100vw/1440) 一致；≥1440 为 1 */
    function ugMfGetPcLayoutScale() {
      const w = window.innerWidth || document.documentElement.clientWidth || 1440;
      if (w >= 1440) return 1;
      if (w >= 1024) return w / 1440;
      return 1;
    }

    function ugMfScaleBannerLayerPx(value, isMb) {
      const n = Number(value) || 0;
      if (isMb) return n * ugMfGetMbMuScale();
      const pcScale = ugMfGetPcLayoutScale();
      return n * pcScale;
    }

    function ugMfLayerTop(layer, pcAttr, mbAttr, fallbackPc) {
      const desktop = ugMfParseNum(layer.getAttribute(pcAttr), fallbackPc);
      if (ugMfIsMobile()) {
        const mb = ugMfParseNum(layer.getAttribute(mbAttr), desktop * UG_MF_MB_TOP_SCALE);
        return ugMfScaleBannerLayerPx(mb, true);
      }
      return ugMfScaleBannerLayerPx(desktop, false);
    }

    function ugMfSyncBannerLayerLayout(root) {
      if (!root || !root._ugMfBannerAutoDone) return;
      const gsap = window.gsap;
      const pin = root._ugMfBannerPin;
      const layers = root._ugMfBannerLayers;
      if (!gsap || !pin || !layers || !layers.length) return;

      const isMb = ugMfIsMobile();
      if (!isMb && ugMfGetPcLayoutScale() === 1) return;

      root._ugMfBannerMetrics = ugMfGetLayerMetrics(layers);
      const st = root._ugMfBannerScrollTrigger;
      if (st && st.isActive && typeof st.progress === 'number' && st.progress > 0) {
        ugMfApplyBannerScrollProgress(root, st.progress);
        return;
      }
      ugMfSetLayersAtAuto(pin, gsap, layers);
    }
  
    function ugMfLayerStartTop(layer) {
      return ugMfLayerTop(layer, 'data-start-top-pc', 'data-start-top-mb', 0);
    }
  
    function ugMfLayerAutoTop(layer) {
      return ugMfLayerTop(
        layer,
        'data-auto-top-pc',
        'data-auto-top-mb',
        ugMfLayerStartTop(layer)
      );
    }
  
    function ugMfLayerScrollEndTop(layer) {
      return ugMfLayerTop(
        layer,
        'data-exit-top-pc',
        'data-exit-top-mb',
        ugMfLayerAutoTop(layer)
      );
    }
  
    function ugMfLayerScrollDistance(layer) {
      return Math.max(Math.abs(ugMfLayerScrollEndTop(layer) - ugMfLayerAutoTop(layer)), 1);
    }
  
    function ugMfLayerAutoDuration(layer) {
      const custom = layer.getAttribute('data-auto-duration');
      if (custom !== null && custom !== '') {
        return ugMfParseNum(custom, UG_MF_AUTO_DUR);
      }
      return UG_MF_AUTO_DUR;
    }
  
    function ugMfGetLayerMetrics(layers) {
      return layers.map((layer, index) => ({
        layer,
        index,
        start: ugMfLayerStartTop(layer),
        auto: ugMfLayerAutoTop(layer),
        end: ugMfLayerScrollEndTop(layer),
        autoDur: ugMfLayerAutoDuration(layer),
      }));
    }
  
    function ugMfLockViewportScroll(root, lock) {
      if (!root) return;
  
      if (!lock) {
        root._ugMfBannerAutoPlaying = false;
        if (root._ugMfScrollLockHandler) {
          window.removeEventListener('scroll', root._ugMfScrollLockHandler);
          root._ugMfScrollLockHandler = null;
        }
        return;
      }
  
      root._ugMfBannerAutoPlaying = true;
      root._ugMfLockedScrollY = window.scrollY;
  
      const handler = () => {
        if (!root._ugMfBannerAutoPlaying) return;
        const currentScrollY = window.scrollY || 0;
        if (currentScrollY !== root._ugMfLockedScrollY) {
          const restoreDelta = Math.abs(currentScrollY - root._ugMfLockedScrollY);
          const restoreThreshold = Math.min(240, (window.innerHeight || 960) * 0.25);
          if (restoreDelta > restoreThreshold && ugMfAbortBannerAutoForRestoredScroll(root)) {
            return;
          }
          window.scrollTo(0, root._ugMfLockedScrollY);
        }
      };
  
      root._ugMfScrollLockHandler = handler;
      window.addEventListener('scroll', handler, { passive: true });
    }
  
    function ugMfGetUniformScrollDuration(layers) {
      const distances = layers.map(ugMfLayerScrollDistance);
      const minDist = Math.min.apply(null, distances);
      const maxDist = Math.max.apply(null, distances);
      const ratio = Math.min(maxDist / minDist, UG_MF_SCROLL_DIST_RATIO_CAP);
      return UG_MF_SCROLL_DUR * ratio;
    }
  
    function ugMfGetScrollTimelineSpec(layers) {
      const scrollDur = ugMfGetUniformScrollDuration(layers);
      return {
        scrollDur,
        scrollStagger: UG_MF_SCROLL_STAGGER,
        scrollStart: 0,
      };
    }
  
    function ugMfClamp01(value) {
      return Math.max(0, Math.min(1, Number(value) || 0));
    }
  
    function ugMfLayerBaseProps() {
      return {
        xPercent: -50,
        transformOrigin: '50% 100%',
        force3D: true,
      };
    }
  
    function ugMfSetBannerPinActive(root, active) {
      const pin = root && root._ugMfBannerPin;
      const zone = root && (root._ugMfBannerScrollZone || ugMfGetBannerScrollZone(root));
      if (pin) {
        pin.classList.toggle('is-pin-active', !!active);
      }
      if (zone) {
        zone.classList.toggle('is-zone-pinned', !!active);
      }
      if (root) {
        root.classList.toggle('ug-mf--banner-manual-active', !!active);
      }
      document.documentElement.classList.toggle('ug-mf-banner-header-visible', !!active);
    }
  
    function ugMfSyncBannerManualProgress(root) {
      if (root && root._ugMfBannerReverse) return ugMfSyncSkipAutoReverseBanner(root);
  
      const st = root && root._ugMfBannerScrollTrigger;
      if (!st || typeof st.start !== 'number' || typeof st.end !== 'number') return false;
  
      const y = window.scrollY || 0;
      const progress =
        typeof st.progress === 'number'
          ? ugMfClamp01(st.progress)
          : ugMfClamp01((y - st.start) / Math.max(st.end - st.start, 1));
  
      ugMfApplyBannerScrollProgress(root, progress);
      ugMfSetBannerPinActive(root, !!st.isActive);
      ugMfSyncBannerScrollState(root);
      ugMfSyncBannerScrollPhase(root);
      ugMfBannerDebug(root, 'sync', {
        computedProgress: Number(progress.toFixed(4)),
      });
      return true;
    }
  
    function ugMfGetSkipAutoReverseVisualProgress(root) {
      const reverse = root && root._ugMfBannerReverse;
      if (!reverse) return null;
      if (reverse.phase === 'approach') return 1;
  
      const st = root._ugMfBannerReverseSt;
      if (st && typeof st.progress === 'number') {
        return ugMfClamp01(1 - st.progress);
      }
  
      if (reverse.phase === 'animating' && reverse.startY != null && reverse.endY != null) {
        const y = window.scrollY || 0;
        const range = Math.max(reverse.startY - reverse.endY, 1);
        return ugMfClamp01((y - reverse.endY) / range);
      }
  
      if (reverse.phase === 'done') return 0;
      return null;
    }
  
    function ugMfIsBannerFullyVisible(root) {
      const pin = root && root._ugMfBannerPin;
      if (!pin) return false;
  
      const rect = pin.getBoundingClientRect();
      const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
      const headerOffset = ugMfGetHeaderOffset(root);
      const topLimit = Math.max(0, headerOffset);
      const bottomLimit = viewportH - 2;
  
      if (rect.height <= viewportH - topLimit) {
        return rect.top >= topLimit - 2 && rect.bottom <= bottomLimit + 2;
      }
  
      return rect.top <= topLimit + 2 && rect.bottom >= bottomLimit - 2;
    }
  
    function ugMfKillBannerReverseMode(root) {
      if (!root) return;
  
      if (root._ugMfBannerReverseSt) {
        try {
          root._ugMfBannerReverseSt.kill();
        } catch (e) {
          /* ignore */
        }
        root._ugMfBannerReverseSt = null;
      }
  
      if (root._ugMfBannerReverseSync) {
        window.removeEventListener('scroll', root._ugMfBannerReverseSync);
        window.removeEventListener('resize', root._ugMfBannerReverseSync);
        root._ugMfBannerReverseSync = null;
      }
  
      root._ugMfBannerReverse = null;
    }
  
    function ugMfPreserveScrollAroundBannerRefresh(callback) {
      const savedY = window.scrollY || 0;
  
      try {
        callback();
      } finally {
        if (Math.abs(window.scrollY - savedY) > 20) {
          window.scrollTo(0, savedY);
        }
      }
    }
  
    function ugMfActivateSkipAutoReverseScrollTrigger(root, pin, reverse) {
      const ScrollTrigger = window.ScrollTrigger;
      if (!ScrollTrigger || !reverse) return null;
  
      const sectionId = root.getAttribute('data-section-id') || 'mf';
      const isMb = !!root._ugMfBannerIsMb;
      let st = null;
  
      ugMfPreserveScrollAroundBannerRefresh(() => {
        st = ScrollTrigger.create({
          id: 'ug-mf-banner-reverse-' + sectionId + (isMb ? '-mb' : '-pc'),
          trigger: pin,
          start: reverse.endY,
          end: reverse.startY,
          pin,
          pinSpacing: false,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            ugMfApplyBannerScrollProgress(root, 1 - self.progress);
            ugMfSetBannerPinActive(root, !!self.isActive);
            ugMfSyncBannerScrollState(root);
          },
          onLeaveBack: () => {
            ugMfApplyBannerScrollProgress(root, 0);
            ugMfSetBannerPinActive(root, false);
            ugMfSyncBannerScrollState(root);
          },
          onLeave: () => {
            ugMfApplyBannerScrollProgress(root, 1);
            ugMfSetBannerPinActive(root, false);
            ugMfSyncBannerScrollState(root);
          },
        });
  
        st.refresh();
        st.update();
      });
  
      root._ugMfBannerReverseSt = st;
      ugMfBannerDebug(root, 'reverse ST activated', {
        reverseStartY: Math.round(reverse.startY),
        reverseEndY: Math.round(reverse.endY),
        manualScroll: reverse.manualScroll,
      }, true);
      return st;
    }
  
    function ugMfSyncSkipAutoReverseBanner(root) {
      const reverse = root && root._ugMfBannerReverse;
      if (!reverse || reverse.phase === 'done') return false;
  
      const y = window.scrollY || 0;
  
      if (reverse.phase === 'approach') {
        ugMfApplyBannerScrollProgress(root, 1);
        ugMfSetBannerPinActive(root, false);
        ugMfSyncBannerScrollState(root);
  
        if (!ugMfIsBannerFullyVisible(root)) return true;
  
        reverse.phase = 'animating';
        reverse.startY = y;
        reverse.endY = Math.max(0, y - reverse.manualScroll);
        ugMfActivateSkipAutoReverseScrollTrigger(root, root._ugMfBannerPin, reverse);
        ugMfApplyBannerScrollProgress(root, 1);
        ugMfBannerDebug(root, 'reverse visible gate open', {
          reverseStartY: Math.round(reverse.startY),
          reverseEndY: Math.round(reverse.endY),
        }, true);
        return true;
      }
  
      const visualProgress = ugMfGetSkipAutoReverseVisualProgress(root);
      if (visualProgress === null) return false;
  
      ugMfApplyBannerScrollProgress(root, visualProgress);
      const st = root._ugMfBannerReverseSt;
      ugMfSetBannerPinActive(root, !!(st && st.isActive));
      ugMfSyncBannerScrollState(root);
  
      if (visualProgress <= 0.01 && y <= reverse.endY + 4) {
        ugMfCompleteSkipAutoReverse(root);
      }
  
      return true;
    }
  
    function ugMfCompleteSkipAutoReverse(root) {
      const reverse = root && root._ugMfBannerReverse;
      if (!reverse || reverse.phase === 'done') return;
  
      reverse.phase = 'done';
  
      const pin = root._ugMfBannerPin;
      const stage = root._ugMfBannerStage;
      const layers = root._ugMfBannerLayers;
      const bannerCopy = root._ugMfBannerCopy || [];
      const metrics = root._ugMfBannerMetrics;
      const spec = root._ugMfBannerSpec;
  
      ugMfKillBannerReverseMode(root);
      root._ugMfBannerSkipAuto = false;
      ugMfApplyBannerScrollProgress(root, 0);
      ugMfSetBannerPinActive(root, false);
  
      if (!pin || !stage || !layers || !metrics || !spec) return;
  
      const savedY = window.scrollY || 0;
      ugMfCreateBannerScrollTimeline(root, pin, stage, metrics, bannerCopy, spec);
  
      requestAnimationFrame(() => {
        const st = root._ugMfBannerScrollTrigger;
        if (!st) return;
  
        ugMfPreserveScrollAroundBannerRefresh(() => {
          st.refresh();
          st.update();
        });
  
        ugMfSyncBannerManualProgress(root);
        ugMfSyncBannerScrollState(root);
        ugMfUpdateStickyBarVisibility(root);
  
        if (Math.abs(window.scrollY - savedY) > 20) {
          ugMfBannerDebug(root, 'reverse complete scroll preserved', {
            savedY: Math.round(savedY),
            currentY: Math.round(window.scrollY || 0),
          }, true);
        }
      });
  
      ugMfBannerDebug(root, 'reverse complete -> normal ST', null, true);
    }
  
    function ugMfStartSkipAutoReverseBanner(root, pin, stage, layers, bannerCopy, metrics, spec) {
      const isMb = ugMfIsMobile();
      ugMfPrepareBannerPinForMode(root, pin, isMb);
  
      root._ugMfBannerMetrics = metrics;
      root._ugMfBannerSpec = spec;
      root._ugMfBannerIsMb = isMb;
      root._ugMfBannerReverse = {
        phase: 'approach',
        manualScroll: ugMfGetManualScrollRange(),
        startY: null,
        endY: null,
      };
  
      ugMfApplyBannerScrollProgress(root, 1);
  
      const tick = () => {
        ugMfSyncSkipAutoReverseBanner(root);
      };
  
      root._ugMfBannerReverseSync = ugMfRafThrottle(tick);
      window.addEventListener('scroll', root._ugMfBannerReverseSync, { passive: true });
      window.addEventListener('resize', root._ugMfBannerReverseSync, { passive: true });
      tick();
  
      ugMfInitAfterBannerReady(root);
      ugMfMarkLayoutDirty(root);
      ugMfBannerDebug(root, 'skipAuto reverse mode started', {
        manualScroll: root._ugMfBannerReverse.manualScroll,
        isMb,
      }, true);
    }
  
    function ugMfIsPageAtBannerTop(pin) {
      if (!pin) return true;
      const scrollY = window.scrollY || 0;
      const rect = pin.getBoundingClientRect();
      const pinDocTop = rect.top + scrollY;
      return scrollY <= pinDocTop + 8;
    }
  
    function ugMfShouldSkipBannerAuto(root, pin) {
      if (ugMfIsMobile()) return false;
      return !ugMfIsPageAtBannerTop(pin);
    }
  
    function ugMfAbortBannerAutoForRestoredScroll(root) {
      const gsap = window.gsap;
      const pin = root && root._ugMfBannerPin;
      const stage = root && root._ugMfBannerStage;
      const layers = root && root._ugMfBannerLayers;
      const bannerCopy = root && root._ugMfBannerCopy;
      if (!root || !root._ugMfBannerAutoPlaying || !gsap || !pin || !stage || !layers) {
        return false;
      }
  
      if (!ugMfShouldSkipBannerAuto(root, pin)) return false;
  
      ugMfClearBannerAutoTimers(root);

      if (root._ugMfBannerAutoTimeline) {
        root._ugMfBannerAutoTimeline.kill();
        root._ugMfBannerAutoTimeline = null;
      }

      root._ugMfBannerSkipAuto = true;
      ugMfLockViewportScroll(root, false);
      ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy || []);
      return true;
    }
  
    function ugMfIsBannerScrollActive(root) {
      const st = root && root._ugMfBannerScrollTrigger;
      const reverseSt = root && root._ugMfBannerReverseSt;
      return Boolean((st && st.isActive) || (reverseSt && reverseSt.isActive));
    }
  
    function ugMfIsBannerScrollComplete(root) {
      if (!root) return false;
  
      if (root._ugMfBannerStaticMb && root._ugMfBannerReducedMotion) {
        return true;
      }
  
      if (root._ugMfBannerReverse) {
        return root._ugMfBannerReverse.phase === 'done';
      }
  
      const st = root._ugMfBannerScrollTrigger;
      if (st && typeof st.end === 'number') {
        return window.scrollY >= st.end - 2;
      }
  
      if (!root.querySelector('[data-mf-banner-pin]')) {
        return true;
      }
  
      if (root._ugMfBannerReducedMotion) {
        const pin = root._ugMfBannerPin || root.querySelector('[data-mf-banner-pin]');
        if (!pin) return false;
        return window.scrollY >= pin.offsetTop + pin.offsetHeight - 2;
      }
  
      return false;
    }
  
    function ugMfSyncBannerScrollState(root) {
      if (!root) return;
      root.classList.toggle('ug-mf--banner-scroll-done', ugMfIsBannerScrollComplete(root));
    }
  
    function ugMfResetBannerScrollVisual(root) {
      const gsap = window.gsap;
      const pin = root && root._ugMfBannerPin;
      const layers = root && root._ugMfBannerLayers;
      const bannerCopy = root && root._ugMfBannerCopy;
      const tl = root && root._ugMfBannerTimeline;
      if (!gsap || !pin || !layers || !layers.length) return;
  
      if (tl) {
        ugMfApplyBannerScrollProgress(root, 0);
      } else {
        ugMfSetLayersAtAuto(pin, gsap, layers);
        if (bannerCopy && bannerCopy.length) {
          gsap.set(bannerCopy, { opacity: 1 });
        }
      }
    }
  
    function ugMfResetBannerLayers(pin, root) {
      if (!pin) return;
  
      const sectionRoot = root || pin.closest('.ug-mf');
      ugMfSetBannerScrollPad(sectionRoot, pin, 0);
  
      pin.style.removeProperty('height');
      pin.style.removeProperty('min-height');
      pin.style.removeProperty('max-height');
      pin.style.removeProperty('overflow');
  
      if (sectionRoot) {
        ugMfClearMbBannerLayout(sectionRoot);
      }
  
      const stage = pin.querySelector('[data-mf-banner-stage]');
      if (stage) {
        stage.style.removeProperty('position');
        stage.style.removeProperty('top');
        stage.style.removeProperty('left');
        stage.style.removeProperty('right');
        stage.style.removeProperty('z-index');
        stage.style.removeProperty('max-width');
        stage.style.removeProperty('margin-left');
        stage.style.removeProperty('margin-right');
      }
  
      pin.querySelectorAll('[data-mf-layer]').forEach((layer) => {
        layer.style.removeProperty('top');
        layer.style.removeProperty('transform');
        layer.style.removeProperty('opacity');
        layer.style.removeProperty('scale');
      });
  
      pin.querySelectorAll('[data-mf-banner-copy]').forEach((el) => {
        el.style.removeProperty('opacity');
      });
    }
  
    function ugMfKillBannerAnimation(root) {
      if (!root) return;
  
      ugMfSetStickyBarVisible(root, false);
  
      const banner = root.querySelector('.ug-mf-banner');
      if (banner) {
        banner.classList.remove('is-gsap-ready');
      }
  
      if (root._ugMfBannerAutoTimeline) {
        root._ugMfBannerAutoTimeline.kill();
        root._ugMfBannerAutoTimeline = null;
      }
  
      ugMfClearBannerAutoTimers(root);

      if (root._ugMfBannerIntroTimer) {
        window.clearTimeout(root._ugMfBannerIntroTimer);
        root._ugMfBannerIntroTimer = null;
      }
  
      root._ugMfBannerAutoDone = false;
  
      if (root._ugMfBannerTimeline) {
        root._ugMfBannerTimeline.kill();
        root._ugMfBannerTimeline = null;
      }
  
      if (root._ugMfBannerScrollTrigger) {
        try {
          root._ugMfBannerScrollTrigger.kill();
        } catch (e) {
          /* ignore */
        }
        root._ugMfBannerScrollTrigger = null;
      }
  
      root._ugMfBannerScrollBuilt = false;
      ugMfLockViewportScroll(root, false);
      ugMfSetBannerPinActive(root, false);
      document.documentElement.classList.remove('ug-mf-banner-header-visible');
      root.classList.remove('ug-mf--banner-scroll-done');
      root._ugMfBannerReducedMotion = false;
      root._ugMfSecondaryReady = false;
      root._ugMfScrollEffectsReady = false;
      root._ugMfBannerDeferQueue = null;
      root._ugMfBannerSkipAuto = false;
      root._ugMfBannerPin = null;
      root._ugMfBannerScrollZone = null;
      root._ugMfBannerStage = null;
      root._ugMfBannerLayers = null;
      root._ugMfBannerCopy = null;
      root._ugMfBannerMetrics = null;
      root._ugMfBannerSpec = null;
      root._ugMfBannerStaticMb = false;
  
      if (root._ugMfBannerResize) {
        window.removeEventListener('resize', root._ugMfBannerResize);
        root._ugMfBannerResize = null;
      }
  
      if (root._ugMfBannerRefreshTimer) {
        window.clearTimeout(root._ugMfBannerRefreshTimer);
        root._ugMfBannerRefreshTimer = null;
      }
  
      if (root._ugMfStickyBarGate) {
        window.removeEventListener('scroll', root._ugMfStickyBarGate);
        root._ugMfStickyBarGate = null;
      }
  
      if (root._ugMfBannerRestoredScrollSync) {
        window.removeEventListener('scroll', root._ugMfBannerRestoredScrollSync);
        window.removeEventListener('resize', root._ugMfBannerRestoredScrollSync);
        root._ugMfBannerRestoredScrollSync = null;
      }
      if (root._ugMfBannerRestoredRawTrace) {
        window.removeEventListener('scroll', root._ugMfBannerRestoredRawTrace);
        root._ugMfBannerRestoredRawTrace = null;
      }
      ugMfKillBannerReverseMode(root);
      ugMfClearBannerScrollPhase(root);
  
      ugMfKillScrollSync(root);
      ugMfKillSecondaryFeatures(root);
  
      const gsap = window.gsap;
      const pin = root.querySelector('[data-mf-banner-pin]');
      if (gsap && pin) {
        gsap.killTweensOf(pin.querySelectorAll('[data-mf-layer], [data-mf-banner-copy]'));
      }
  
      if (pin) {
        ugMfCleanupBannerPinSpacer(pin);
      }
      const scrollZone = ugMfGetBannerScrollZone(root);
      if (scrollZone) {
        ugMfCleanupBannerPinSpacer(scrollZone);
      }
      ugMfResetBannerLayers(pin, root);
      root.classList.remove('ug-mf--banner-mb', 'ug-mf--banner-pc');
      root._ugMfBannerLayoutMode = null;
      root._ugMfBannerIsMb = null;
    }
  
    function ugMfKillSubnav(root) {
      if (!root) return;
  
      root._ugMfSubnavScrollSpy = null;
  
      if (root._ugMfSubnavResize) {
        window.removeEventListener('resize', root._ugMfSubnavResize);
        root._ugMfSubnavResize = null;
      }
  
      root._ugMfSubnavSections = null;
      root._ugMfSubnavTopsDirty = false;
    }
  
    function ugMfSetLayersFinal(pin, gsap) {
      pin.querySelectorAll('[data-mf-layer]').forEach((layer) => {
        gsap.set(layer, {
          ...ugMfLayerBaseProps(),
          top: ugMfLayerScrollEndTop(layer),
          y: 0,
          opacity: 1,
          scale: 1,
        });
      });
    }
  
    function ugMfSetLayersAtStart(pin, gsap, layers) {
      const isMb = ugMfIsMobile();
      layers.forEach((layer, index) => {
        gsap.set(layer, {
          ...ugMfLayerBaseProps(),
          top: ugMfLayerStartTop(layer),
          y: 0,
          opacity: 1,
          scale: isMb
            ? 1
            : UG_MF_LAYER_START_SCALE[index] !== undefined
              ? UG_MF_LAYER_START_SCALE[index]
              : 1,
        });
      });
    }
  
    function ugMfSetLayersAtAuto(pin, gsap, layers) {
      layers.forEach((layer) => {
        gsap.set(layer, {
          ...ugMfLayerBaseProps(),
          top: ugMfLayerAutoTop(layer),
          y: 0,
          opacity: 1,
          scale: 1,
        });
      });
    }
  
    function ugMfSetLayersAtEnd(pin, gsap, layers) {
      layers.forEach((layer) => {
        gsap.set(layer, {
          ...ugMfLayerBaseProps(),
          top: ugMfLayerScrollEndTop(layer),
          y: 0,
          opacity: 1,
          scale: 1,
        });
      });
    }
  
    function ugMfSetBannerCopyAtEnd(gsap, bannerCopy) {
      if (bannerCopy && bannerCopy.length) {
        gsap.set(bannerCopy, { opacity: 0 });
      }
    }
  
    function ugMfApplyBannerScrollProgress(root, progress) {
      const gsap = window.gsap;
      const pin = root && root._ugMfBannerPin;
      const layers = root && root._ugMfBannerLayers;
      const bannerCopy = root && root._ugMfBannerCopy;
      const metrics = root && (root._ugMfBannerMetrics || (layers && ugMfGetLayerMetrics(layers)));
      const spec = root && (root._ugMfBannerSpec || (layers && ugMfGetScrollTimelineSpec(layers)));
      if (!gsap || !pin || !metrics || !metrics.length) return;
  
      const { scrollDur, scrollStagger, scrollStart } = spec;
      const totalDur = scrollStart + scrollDur + (metrics.length - 1) * scrollStagger;
      const time = ugMfClamp01(progress) * totalDur;
  
      metrics.forEach((entry) => {
        const layerStart = scrollStart + entry.index * scrollStagger;
        const layerProgress = ugMfClamp01((time - layerStart) / scrollDur);
  
        gsap.set(entry.layer, {
          ...ugMfLayerBaseProps(),
          top: entry.auto + (entry.end - entry.auto) * layerProgress,
          y: 0,
          opacity: 1,
          scale: 1,
        });
      });
  
      if (bannerCopy && bannerCopy.length) {
        const copyProgress = ugMfClamp01((time - scrollStart) / scrollDur);
        gsap.set(bannerCopy, { opacity: 1 - copyProgress });
      }
  
      ugMfSyncBannerScrollPhase(root);
    }
  
    function ugMfPopulateBannerScrollTimeline(tl, metrics, bannerCopy, spec) {
      const { scrollDur, scrollStagger, scrollStart } = spec;
  
      metrics.forEach((entry, index) => {
        tl.fromTo(
          entry.layer,
          {
            top: entry.auto,
            y: 0,
            opacity: 1,
            scale: 1,
            immediateRender: false,
            ...ugMfLayerBaseProps(),
          },
          {
            top: entry.end,
            ease: 'none',
            duration: scrollDur,
            immediateRender: false,
            ...ugMfLayerBaseProps(),
          },
          scrollStart + index * scrollStagger
        );
      });
  
      if (bannerCopy.length) {
        tl.fromTo(
          bannerCopy,
          {
            opacity: 1,
            immediateRender: false,
          },
          {
            opacity: 0,
            ease: 'none',
            duration: scrollDur,
            immediateRender: false,
          },
          scrollStart
        );
      }
    }
  
    /** Banner 手动段：PC / MB 分支完全隔离，避免共用逻辑互相污染 */
    function ugMfPrepareBannerPinForMode(root, pin, isMobile) {
      if (!pin) return;
  
      ugMfSetBannerLayoutMode(root, isMobile);
      pin.style.removeProperty('height');
      pin.style.removeProperty('min-height');
      ugMfSetBannerScrollPad(root, pin, 0);
    }
  
    function ugMfClearMbBannerLayout(root) {
      if (!root) return;
      root.classList.remove('ug-mf--banner-mb-scroll-ready');
    }
  
    function ugMfMountBannerScroll(root, pin, stage, metrics, bannerCopy, spec, isMb) {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return null;

      const mode = isMb ? 'mb' : 'pc';
      const manualScroll = isMb ? UG_MF_SCROLL_MANUAL_MB : UG_MF_SCROLL_MANUAL_PC;
      const sectionId = root.getAttribute('data-section-id') || 'mf';
      const scrollZone = ugMfGetBannerScrollZone(root) || pin;
      const pinTarget = scrollZone;

      root._ugMfBannerScrollZone = scrollZone;
      root._ugMfBannerStaticMb = false;
      root.style.setProperty('--ug-mf-banner-manual-scroll', manualScroll + 'px');
      root.classList.remove(
        'ug-mf--banner-scroll-done',
        'ug-mf--banner-manual-active',
        'ug-mf--banner-scroll-in-progress',
        'ug-mf--banner-scroll-handoff',
        'ug-mf--banner-idle'
      );
  
      const scrollTl = gsap.timeline({
        paused: true,
        defaults: { ease: 'none' },
      });
  
      ugMfPopulateBannerScrollTimeline(scrollTl, metrics, bannerCopy, spec);
  
      scrollTl.scrollTrigger = ScrollTrigger.create({
        id: 'ug-mf-banner-' + sectionId + '-' + mode,
        trigger: scrollZone,
        start: 'top top',
        end: '+=' + manualScroll,
        pin: pinTarget,
        pinSpacing: true,
        anticipatePin: 1,
        fastScrollEnd: false,
        invalidateOnRefresh: true,
        onEnter: (self) => {
          ugMfSetBannerPinActive(root, true);
          ugMfApplyBannerScrollProgress(
            root,
            self && typeof self.progress === 'number' ? self.progress : 0
          );
          ugMfSyncBannerIdleLayout(root);
          ugMfBannerDebug(root, 'onEnter', { mode }, true);
        },
        onEnterBack: (self) => {
          ugMfSetBannerPinActive(root, true);
          ugMfApplyBannerScrollProgress(
            root,
            self && typeof self.progress === 'number' ? self.progress : 1
          );
          ugMfBannerDebug(root, 'onEnterBack', { mode }, true);
        },
        onUpdate: (self) => {
          ugMfApplyBannerScrollProgress(root, self.progress);
          ugMfSyncBannerScrollState(root);
          ugMfSyncBannerScrollPhase(root);
          ugMfBannerDebug(root, 'onUpdate', {
            mode,
            selfProgress: Number(self.progress.toFixed(4)),
          });
        },
        onLeave: () => {
          ugMfHandoffBannerToContent(root);
          ugMfBannerDebug(root, 'onLeave', { mode }, true);
        },
        onLeaveBack: () => {
          ugMfClearBannerScrollPhase(root);
          ugMfSetBannerPinActive(root, false);
          ugMfApplyBannerScrollProgress(root, 0);
          ugMfSyncBannerScrollState(root);
          ugMfSyncBannerIdleLayout(root);
          ugMfUpdateStickyBarVisibility(root);
          ugMfBannerDebug(root, 'onLeaveBack', { mode }, true);
        },
      });
  
      root._ugMfBannerTimeline = scrollTl;
      root._ugMfBannerScrollTrigger = scrollTl.scrollTrigger;
      root._ugMfBannerScrollBuilt = true;
  
      ugMfClearMbBannerLayout(root);
      ugMfSetBannerScrollPad(root, pin, 0);
  
      const st = scrollTl.scrollTrigger;
      ugMfBannerDebug(
        root,
        'mounted banner scroll',
        { mode, manualScroll, pinSpacing: true, pinTarget: pinTarget.className || 'scroll-zone' },
        true
      );
  
      requestAnimationFrame(() => {
        try {
          ugMfPreserveScrollAroundBannerRefresh(() => {
            st.refresh();
            st.update();
          });
        } catch (e) {
          /* ignore */
        }
        ugMfBannerDebug(root, mode + ' after refresh/update', null, true);
      });
  
      return scrollTl;
    }
  
    function ugMfCreateBannerScrollTimeline(root, pin, stage, metrics, bannerCopy, spec) {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return null;
  
      const isMb = ugMfIsMobile();
      ugMfPrepareBannerPinForMode(root, pin, isMb);
      root._ugMfBannerIsMb = isMb;
      root._ugMfBannerMetrics = metrics;
      root._ugMfBannerSpec = spec;
  
      return ugMfMountBannerScroll(root, pin, stage, metrics, bannerCopy, spec, isMb);
    }
  
    function ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy) {
      const gsap = window.gsap;
      const metrics = ugMfGetLayerMetrics(layers);
      const spec = ugMfGetScrollTimelineSpec(layers);
      ugMfBannerDebug(root, 'finish auto start', { skipAuto: !!root._ugMfBannerSkipAuto }, true);
  
      ugMfLockViewportScroll(root, false);
      ugMfClearBannerAutoTimers(root);
      root._ugMfBannerAutoRunning = false;
      root._ugMfBannerAutoDone = true;
      root._ugMfBannerAutoTimeline = null;
  
      if (root._ugMfBannerSkipAuto) {
        ugMfSetLayersAtEnd(pin, gsap, layers);
        ugMfSetBannerCopyAtEnd(gsap, bannerCopy);
      } else {
        ugMfSetLayersAtAuto(pin, gsap, layers);
        if (bannerCopy.length) {
          gsap.set(bannerCopy, { opacity: 1 });
        }
      }
  
      if (root._ugMfBannerTimeline) {
        root._ugMfBannerTimeline.kill();
        root._ugMfBannerTimeline = null;
        root._ugMfBannerScrollTrigger = null;
        root._ugMfBannerScrollBuilt = false;
      }
  
      const scrollTl = ugMfCreateBannerScrollTimeline(
        root,
        pin,
        stage,
        metrics,
        bannerCopy,
        spec
      );
      if (!scrollTl) {
        root.classList.remove('ug-mf--banner-idle');
        ugMfInitAfterBannerReady(root);
        ugMfInitScrollEffects(root);
        ugMfSyncBannerScrollState(root);
        ugMfUpdateStickyBarVisibility(root);
        ugMfBannerDebug(root, 'finish auto without ScrollTrigger', null, true);
        return;
      }
      ugMfBannerDebug(
        root,
        root._ugMfBannerSkipAuto ? 'finish auto created ST (restored scroll)' : 'finish auto created ST',
        null,
        true
      );
  
      ugMfMarkLayoutDirty(root);
  
      requestAnimationFrame(() => {
        ugMfRefreshBannerScroll(root, true);
        requestAnimationFrame(() => {
          ugMfSyncBannerManualProgress(root);
          ugMfSyncBannerScrollState(root);
          ugMfSyncBannerIdleLayout(root);
          if (ugMfIsBannerScrollComplete(root)) {
            ugMfNotifyBannerScrollComplete(root);
          }
        });
      });
    }
  
    function ugMfRunBannerAutoIntro(root, pin, stage, layers, bannerCopy) {
      const gsap = window.gsap;
  
      if (root._ugMfBannerAutoDone) {
        ugMfBannerDebug(root, 'auto already done', null, true);
        ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy);
        return;
      }
  
      if (ugMfShouldSkipBannerAuto(root, pin)) {
        root._ugMfBannerSkipAuto = true;
        ugMfBannerDebug(root, 'skip auto - restored below banner', null, true);
        ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy);
        return;
      }
  
      root._ugMfBannerSkipAuto = false;
      root._ugMfBannerAutoRunning = true;
      ugMfBannerDebug(root, 'auto intro start', null, true);
      ugMfClearBannerAutoTimers(root);

      if (root._ugMfBannerAutoTimeline) {
        root._ugMfBannerAutoTimeline.kill();
      }
      ugMfLockViewportScroll(root, true);
  
      root._ugMfBannerAutoRestoreTimer = window.setTimeout(() => {
        root._ugMfBannerAutoRestoreTimer = null;
        if (!root._ugMfBannerAutoPlaying) return;
        const scrollY = window.scrollY || 0;
        const lockedY = root._ugMfLockedScrollY || 0;
        if (Math.abs(scrollY - lockedY) > 2 && !ugMfAbortBannerAutoForRestoredScroll(root)) {
          ugMfForceCompleteBannerAuto(root);
        }
      }, 350);

      root._ugMfBannerAutoFailsafeTimer = window.setTimeout(() => {
        root._ugMfBannerAutoFailsafeTimer = null;
        if (root._ugMfBannerAutoRunning) {
          ugMfBannerDebug(root, 'auto failsafe finish', null, true);
          ugMfForceCompleteBannerAuto(root);
        }
      }, Math.round((UG_MF_AUTO_DUR + 0.75) * 1000));

      const autoTweenProps = {
        top: (index, target) => ugMfLayerAutoTop(target),
        duration: UG_MF_AUTO_DUR,
        ease: UG_MF_AUTO_EASE,
        ...ugMfLayerBaseProps(),
        onComplete: () => {
          ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy);
        },
      };
      if (!ugMfIsMobile()) {
        autoTweenProps.scale = 1;
      }
      root._ugMfBannerAutoTimeline = gsap.to(layers, autoTweenProps);
    }
  
    function ugMfScheduleBannerAutoIntro(root, pin, stage, layers, bannerCopy) {
      if (root._ugMfBannerIntroTimer) {
        window.clearTimeout(root._ugMfBannerIntroTimer);
        root._ugMfBannerIntroTimer = null;
      }
  
      const run = () => {
        root._ugMfBannerIntroTimer = null;
        ugMfRunBannerAutoIntro(root, pin, stage, layers, bannerCopy);
      };

      requestAnimationFrame(run);
    }
  
    function ugMfGetDocTop(el) {
      if (!el) return 0;
      const rect = el.getBoundingClientRect();
      return rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
    }
  
    function ugMfSetSubnavActiveLink(subnav, activeLink) {
      if (!subnav || !activeLink) return;
      subnav.querySelectorAll('.ug-mf-subnav__link').forEach((link) => {
        link.classList.toggle('is-active', link === activeLink);
      });
    }
  
    function ugMfRefreshSubnavSpy(root) {
      if (root && typeof root._ugMfSubnavScrollSpy === 'function') {
        root._ugMfSubnavScrollSpy();
      }
    }
  
    function ugMfBindSubnav(root) {
      const subnav = root.querySelector('[data-mf-subnav]');
      if (!subnav) return;
  
      ugMfKillSubnav(root);
      ugMfApplyStickyTop(root);
  
      const links = Array.from(subnav.querySelectorAll('.ug-mf-subnav__link'));
      links.forEach((link) => {
        link.addEventListener('click', () => {
          ugMfSetSubnavActiveLink(subnav, link);
        });
      });
  
      const anchorLinks = links.filter((link) => link.hasAttribute('data-mf-nav-anchor'));
      if (!anchorLinks.length) return;
  
      const sections = anchorLinks
        .map((link) => {
          const id = link.getAttribute('data-mf-nav-anchor');
          if (!id) return null;
          const target = document.getElementById(id);
          if (!target) return null;
          return { link, target, top: ugMfGetDocTop(target) };
        })
        .filter(Boolean)
        .sort((a, b) => a.top - b.top);
  
      if (!sections.length) return;
  
      root._ugMfSubnavSections = sections;
      root._ugMfSubnavTopsDirty = true;
  
      function ugMfRefreshSubnavSectionTops() {
        sections.forEach((entry) => {
          entry.top = ugMfGetDocTop(entry.target);
        });
        root._ugMfSubnavTopsDirty = false;
      }
  
      function updateActiveByScroll() {
        if (root._ugMfSubnavTopsDirty) {
          ugMfRefreshSubnavSectionTops();
        }
  
        const offset = ugMfGetHeaderOffset(root) + (subnav.offsetHeight || 48) + 8;
        const scrollPos = window.scrollY + offset;
        let current = sections[0].link;
  
        sections.forEach((entry) => {
          if (entry.top <= scrollPos) {
            current = entry.link;
          }
        });
  
        const last = sections[sections.length - 1];
        const lastBottom = ugMfGetDocTop(last.target) + last.target.offsetHeight;
        if (scrollPos >= lastBottom - 2) {
          current = last.link;
        }
  
        ugMfSetSubnavActiveLink(subnav, current);
      }
  
      root._ugMfSubnavScrollSpy = updateActiveByScroll;
      updateActiveByScroll();
      ugMfEnsureScrollSync(root);
  
      root._ugMfSubnavResize = ugMfDebounce(() => {
        ugMfApplyStickyTop(root);
        ugMfMarkLayoutDirty(root);
        ugMfRefreshSubnavSpy(root);
      }, 150);
      window.addEventListener('resize', root._ugMfSubnavResize, { passive: true });
  
      subnav.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (ev) => {
          const id = link.getAttribute('href');
          if (!id || id === '#') return;
          if (!ugMfScrollToSectionAnchor(root, id)) return;
          ev.preventDefault();
        });
      });
    }
  
    /** 只刷新本 section 的 banner ScrollTrigger，避免轮播等兄弟节点改动触发全页 ST 重算 */
    function ugMfRefreshBannerScroll(root, force) {
      if (root && root._ugMfBannerReverse) {
        ugMfSyncSkipAutoReverseBanner(root);
        return;
      }
  
      const st = root && root._ugMfBannerScrollTrigger;
      if (!st || typeof st.refresh !== 'function') return;
      if (root._ugMfBannerAutoPlaying) return;
      if (!force && ugMfIsBannerScrollActive(root)) return;
  
      if (force) {
        try {
          st.refresh();
        } catch (e) {
          /* ignore */
        }
      }
  
      if (st.spacer) {
        st.spacer.style.backgroundColor = '#0a1628';
      }
  
      ugMfSyncBannerManualProgress(root);
    }
  
    function ugMfScheduleBannerScrollRefresh(root) {
      if (!root || root._ugMfBannerAutoPlaying || ugMfIsBannerScrollActive(root)) return;
  
      if (root._ugMfBannerRefreshTimer) {
        window.clearTimeout(root._ugMfBannerRefreshTimer);
      }
  
      root._ugMfBannerRefreshTimer = window.setTimeout(() => {
        root._ugMfBannerRefreshTimer = null;
        ugMfRefreshBannerScroll(root);
      }, 200);
    }
  
    /** Banner 手动段就绪后再初始化导航 / 吸底 bar（不含 ScrollTrigger 区块） */
    function ugMfInitAfterBannerReady(root) {
      if (!root || root._ugMfSecondaryReady) return;
      root._ugMfSecondaryReady = true;
  
      ugMfBindSubnav(root);
      ugMfInitStickyBar(root);
      ugMfEnsureScrollSync(root);
      ugMfBindGiveawayForms(root);
    }
  
    /** 滚完 banner 后再挂载 Giveaway / Products / Swiper，避免改布局干扰 pin */
    function ugMfInitScrollEffects(root) {
      if (!root || root._ugMfScrollEffectsReady) return;
      if (!ugMfCanMountScrollEffects(root)) return;
      root._ugMfScrollEffectsReady = true;
  
      ugMfBindGiveaway(root);
      ugMfDeferProductsScroll(root);
      ugMfDeferPartnershipCarousels(root);
    }
  
    function ugMfTryInitScrollEffects(root) {
      if (!root || root._ugMfScrollEffectsReady) {
        ugMfFlushBannerDeferQueue(root);
        return;
      }
      if (!ugMfCanMountScrollEffects(root)) return;
      ugMfInitScrollEffects(root);
      ugMfFlushBannerDeferQueue(root);
    }
  
    function ugMfKillSecondaryFeatures(root) {
      if (!root) return;
  
      root._ugMfSecondaryReady = false;
      root._ugMfScrollEffectsReady = false;
      root._ugMfBannerDeferQueue = null;
  
      if (root._ugMfCarouselIo) {
        root._ugMfCarouselIo.disconnect();
        root._ugMfCarouselIo = null;
      }
  
      if (root._ugMfProductsIo) {
        root._ugMfProductsIo.disconnect();
        root._ugMfProductsIo = null;
      }
  
      if (root._ugMfGiveawayIo) {
        root._ugMfGiveawayIo.disconnect();
        root._ugMfGiveawayIo = null;
      }
  
      ugMfKillSubnav(root);
      ugMfKillPartnershipCarousels(root);
      ugMfKillProductsScroll(root);
      ugMfKillGiveaway(root);
    }
  
    function ugMfBindBannerScroll(root) {
      if (!root || !root.querySelector('[data-mf-banner-pin]')) return false;
  
      if (!ugMfEnsureGsapRegistered()) return false;

      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;

      ugMfKillBannerAnimation(root);
  
      const pin = root.querySelector('[data-mf-banner-pin]');
      const stage = pin.querySelector('[data-mf-banner-stage]');
      const banner = pin.querySelector('.ug-mf-banner');
      const layers = Array.from(pin.querySelectorAll('[data-mf-layer]'));
      const bannerCopy = banner
        ? Array.from(banner.querySelectorAll('[data-mf-banner-copy]'))
        : [];
  
      if (!stage || !banner || !layers.length) return false;
  
      ugMfSyncMobileState();
      ugMfPrepareBannerPinForMode(root, pin, ugMfIsMobile());
      banner.classList.remove('is-gsap-ready');

      if (ugMfPrefersReducedMotion()) {
        if (ugMfIsMobile()) {
          ugMfSetLayersAtAuto(pin, gsap, layers);
          root._ugMfBannerStaticMb = true;
          root._ugMfBannerAutoDone = true;
          root._ugMfBannerIsMb = true;
          root.classList.add('ug-mf--banner-scroll-done');
        } else {
          ugMfSetLayersFinal(pin, gsap);
          root._ugMfBannerStaticMb = false;
        }
        if (bannerCopy.length) {
          gsap.set(bannerCopy, { opacity: 1 });
        }
        banner.classList.add('is-gsap-ready');
        root._ugMfBannerPin = pin;
        root._ugMfBannerReducedMotion = true;
        ugMfSetBannerLayoutMode(root, ugMfIsMobile());
        ugMfInitAfterBannerReady(root);
        ugMfInitScrollEffects(root);
        ugMfSyncBannerScrollState(root);
        ugMfUpdateStickyBarVisibility(root);
        return true;
      }
      const initialMobile = ugMfIsMobile();
      ugMfSetBannerLayoutMode(root, initialMobile);
      root._ugMfBannerWasMobile = initialMobile;
      root._ugMfBannerPin = pin;
      root._ugMfBannerScrollZone = ugMfGetBannerScrollZone(root);
      root._ugMfBannerStage = stage;
      root._ugMfBannerLayers = layers;
      root._ugMfBannerCopy = bannerCopy;
      ugMfBannerDebug(root, 'bind banner', { initialMobile }, true);
      if (ugMfShouldSkipBannerAuto(root, pin)) {
        root._ugMfBannerSkipAuto = true;
        ugMfSetLayersAtEnd(pin, gsap, layers);
        if (bannerCopy.length) {
          gsap.set(bannerCopy, { opacity: 0 });
        }
        banner.classList.add('is-gsap-ready');
        ugMfFinishBannerAuto(root, pin, stage, layers, bannerCopy);
      } else {
        ugMfSetLayersAtStart(pin, gsap, layers);
        if (bannerCopy.length) {
          gsap.set(bannerCopy, { opacity: 1 });
        }
        banner.classList.add('is-gsap-ready');
        ugMfScheduleBannerAutoIntro(root, pin, stage, layers, bannerCopy);
      }
  
      root._ugMfBannerResize = ugMfDebounce(() => {
        ugMfSyncMobileState();
        ugMfApplyStickyTop(root);
        ugMfMarkLayoutDirty(root);
        const nowMobile = ugMfIsMobile();
        if (nowMobile !== root._ugMfBannerWasMobile) {
          root._ugMfBannerWasMobile = nowMobile;
          ugMfBindBannerScroll(root);
          return;
        }
        ugMfSyncBannerLayerLayout(root);
        if (root._ugMfBannerScrollTrigger) {
          try {
            root._ugMfBannerScrollTrigger.refresh();
            root._ugMfBannerScrollTrigger.update();
          } catch (e) {
            /* ignore */
          }
          ugMfSyncBannerManualProgress(root);
        }
        ugMfScheduleBannerScrollRefresh(root);
      }, 150);
      window.addEventListener('resize', root._ugMfBannerResize, { passive: true });
  
      const images = pin.querySelectorAll('[data-mf-layer] img, .ug-mf-banner__bg img');
      let pendingImages = 0;
  
      const onBannerImageSettled = () => {
        pendingImages -= 1;
        if (pendingImages <= 0 && root._ugMfBannerAutoDone) {
          ugMfScheduleBannerScrollRefresh(root);
        }
      };
  
      images.forEach((img) => {
        if (img.complete) return;
        pendingImages += 1;
        img.addEventListener('load', onBannerImageSettled, { once: true });
        img.addEventListener('error', onBannerImageSettled, { once: true });
      });
  
      if (pendingImages === 0 && root._ugMfBannerAutoDone) {
        requestAnimationFrame(() => ugMfScheduleBannerScrollRefresh(root));
      }
  
      return true;
    }
  
    function ugMfGetProductsScale(product) {
      if (ugMfIsMobile()) {
        return {
          start: ugMfParseNum(
            product.getAttribute('data-scale-start-mb'),
            UG_MF_PD_SCALE_START_MB
          ),
          end: ugMfParseNum(product.getAttribute('data-scale-end-mb'), UG_MF_PD_SCALE_END_MB),
        };
      }
  
      return {
        start: ugMfParseNum(
          product.getAttribute('data-scale-start-pc'),
          UG_MF_PD_SCALE_START_PC
        ),
        end: ugMfParseNum(product.getAttribute('data-scale-end-pc'), UG_MF_PD_SCALE_END_PC),
      };
    }
  
    function ugMfKillProductsScroll(root) {
      if (!root) return;
  
      if (root._ugMfProductsIo) {
        root._ugMfProductsIo.disconnect();
        root._ugMfProductsIo = null;
      }
  
      if (root._ugMfProductsResize) {
        window.removeEventListener('resize', root._ugMfProductsResize);
        root._ugMfProductsResize = null;
      }
  
      (root._ugMfProductsAnimations || []).forEach((entry) => {
        if (entry.tween) entry.tween.kill();
        if (entry.product && window.gsap) {
          entry.product.classList.remove('is-gsap-ready');
          window.gsap.set(entry.product, {
            clearProps: 'transform,left,bottom,top,scale,xPercent',
          });
        }
      });
      root._ugMfProductsAnimations = null;
      root._ugMfProductsWasMobile = null;
    }
  
    function ugMfBindOneProductsScroll(root, product) {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      const section = product.closest('.ug-mf-products');
      const panel = product.closest('.ug-mf-products__panel');
      if (!section || !panel) return null;
  
      const scale = ugMfGetProductsScale(product);
      const bottomPx = ugMfIsMobile() ? 142 : 100;
  
      product.classList.add('is-gsap-ready');
  
      gsap.set(product, {
        position: 'absolute',
        left: '50%',
        bottom: bottomPx,
        top: 'auto',
        xPercent: -50,
        transformOrigin: '50% 100%',
        force3D: true,
      });
  
      if (ugMfPrefersReducedMotion()) {
        gsap.set(product, { scale: scale.end });
        return null;
      }
  
      gsap.set(product, { scale: scale.start });
  
      const tween = gsap.fromTo(
        product,
        { scale: scale.start },
        {
          scale: scale.end,
          ease: 'none',
          immediateRender: false,
          scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: '+=' + (ugMfIsMobile() ? UG_MF_PD_SCROLL_MB : UG_MF_PD_SCROLL_PC),
            scrub: UG_MF_PD_SCRUB,
            invalidateOnRefresh: true,
          },
        }
      );
  
      return { tween, product };
    }
  
    function ugMfBindProductsScroll(root) {
      if (!root || !root.querySelector('[data-mf-products-product]')) return false;
  
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return false;
  
      ugMfKillProductsScroll(root);
      ugMfEnsureGsapRegistered();
  
      const animations = [];
  
      root.querySelectorAll('[data-mf-products-product]').forEach((product) => {
        const entry = ugMfBindOneProductsScroll(root, product);
        if (entry) animations.push(entry);
      });
  
      root._ugMfProductsAnimations = animations;
      ugMfSyncMobileState();
      root._ugMfProductsWasMobile = ugMfIsMobile();
      root._ugMfProductsResize = ugMfDebounce(() => {
        ugMfSyncMobileState();
        const nowMobile = ugMfIsMobile();
        if (nowMobile !== root._ugMfProductsWasMobile) {
          root._ugMfProductsWasMobile = nowMobile;
          ugMfBindProductsScroll(root);
          return;
        }
        (root._ugMfProductsAnimations || []).forEach((entry) => {
          if (entry.tween && entry.tween.scrollTrigger) {
            entry.tween.scrollTrigger.refresh();
          }
        });
        ugMfMarkLayoutDirty(root);
        ugMfRefreshSubnavSpy(root);
      }, 150);
      window.addEventListener('resize', root._ugMfProductsResize, { passive: true });
  
      requestAnimationFrame(() => {
        (root._ugMfProductsAnimations || []).forEach((entry) => {
          if (entry.tween && entry.tween.scrollTrigger) {
            entry.tween.scrollTrigger.refresh();
          }
        });
        ugMfMarkLayoutDirty(root);
        ugMfRefreshSubnavSpy(root);
      });
  
      return animations.length > 0;
    }
  
    function ugMfKillPartnershipCarousels(root) {
      if (!root) return;
  
      if (root._ugMfCarouselIo) {
        root._ugMfCarouselIo.disconnect();
        root._ugMfCarouselIo = null;
      }
  
      root.querySelectorAll('[data-mf-partnership-carousel]').forEach((carousel) => {
        if (carousel._ugMfSwiper && typeof carousel._ugMfSwiper.destroy === 'function') {
          try {
            carousel._ugMfSwiper.destroy(true, true);
          } catch (e) {
            /* ignore */
          }
        }
        carousel._ugMfSwiper = null;
      });
    }
  
    function ugMfBindPartnershipCarousels(root) {
      if (!root || typeof window.Swiper === 'undefined') return;
  
      root.querySelectorAll('[data-mf-partnership-carousel]').forEach((carousel) => {
        if (carousel._ugMfSwiper) return;
  
        const swiperEl = carousel.querySelector('.ug-mf-partnership__swiper');
        const prev = carousel.querySelector('[data-mf-carousel-prev]');
        const next = carousel.querySelector('[data-mf-carousel-next]');
        if (!swiperEl) return;
  
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (slides.length < 2) return;
  
        carousel._ugMfSwiper = new window.Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 450,
          autoplay: {
            delay: UG_MF_PARTNERSHIP_CAROUSEL_AUTOPLAY_MS,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation:
            prev && next
              ? {
                  prevEl: prev,
                  nextEl: next,
                }
              : undefined,
        });
      });
    }
  
    function ugMfTeardown(root) {
      ugMfKillBannerAnimation(root);
      ugMfKillSubnav(root);
      ugMfKillPartnershipCarousels(root);
      ugMfKillProductsScroll(root);
      ugMfKillGiveaway(root);
      ugMfKillStickyBar(root);
      if (root) {
        root._ugMfSecondaryReady = false;
        root._ugMfScrollEffectsReady = false;
      }
    }
  
    function ugMfApplyTransparentHeader(enabled) {
      const htmlClass = 'ug-mf-page-transparent-header';
      const h = document.getElementById('header-component');
      if (!enabled || !h) return;
  
      if (!h.hasAttribute('transparent')) {
        h.setAttribute('data-ug-mf-transparent-header', '');
        h.setAttribute('transparent', 'not-sticky');
      }
      document.documentElement.classList.add(htmlClass);
    }
  
    function ugMfRemoveTransparentHeader() {
      const htmlClass = 'ug-mf-page-transparent-header';
      const h = document.getElementById('header-component');
      document.documentElement.classList.remove(htmlClass);
      if (!h || !h.hasAttribute('data-ug-mf-transparent-header')) return;
  
      h.removeAttribute('transparent');
      h.removeAttribute('data-ug-mf-transparent-header');
    }
  
    /** 轮播进入视口后再初始化，避免 Swiper / 页面 load 改布局影响 banner pin */
    function ugMfDeferPartnershipCarousels(root) {
      if (!root) return;
  
      const targets = root.querySelectorAll('[data-mf-partnership-carousel]');
      if (!targets.length) return;
  
      const run = () => {
        ugMfDeferUntilBannerReady(root, () => {
          ugMfBindPartnershipCarousels(root);
        });
      };
  
      if (typeof IntersectionObserver === 'undefined') {
        window.setTimeout(run, 2500);
        return;
      }
  
      if (root._ugMfCarouselIo) {
        root._ugMfCarouselIo.disconnect();
        root._ugMfCarouselIo = null;
      }
  
      const io = new IntersectionObserver(
        (entries, observer) => {
          const hit = entries.some((entry) => entry.isIntersecting);
          if (!hit) return;
  
          observer.disconnect();
          root._ugMfCarouselIo = null;
          run();
        },
        { root: null, rootMargin: '160px 0px', threshold: 0 }
      );
  
      root._ugMfCarouselIo = io;
      targets.forEach((el) => io.observe(el));
    }
  
    function ugMfRafThrottle(fn) {
      let ticking = false;
      return function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          fn();
        });
      };
    }
  
    function ugMfFindFooterEl() {
      if (ugMfFindFooterEl.cached) return ugMfFindFooterEl.cached;
  
      const footerTag =
        document.querySelector('footer.ug-footer') || document.querySelector('footer');
      if (footerTag && footerTag.offsetHeight > 24) {
        ugMfFindFooterEl.cached = footerTag;
        return footerTag;
      }
  
      const sectionNodes = document.querySelectorAll('[id^="shopify-section-"][id*="footer"]');
      for (let i = 0; i < sectionNodes.length; i += 1) {
        const section = sectionNodes[i];
        const inner = section.querySelector('footer');
        if (inner && inner.offsetHeight > 24) {
          ugMfFindFooterEl.cached = inner;
          return inner;
        }
        if (section.offsetHeight > 80) {
          ugMfFindFooterEl.cached = section;
          return section;
        }
      }
  
      const group = document.querySelector('.shopify-section-group-footer-group');
      if (group && group.offsetHeight > 24) {
        ugMfFindFooterEl.cached = group;
        return group;
      }
  
      ugMfFindFooterEl.cached = null;
      return null;
    }
  
    function ugMfGetStickyBar(root) {
      if (!root) return null;
      if (root._ugMfStickyBarEl) return root._ugMfStickyBarEl;
      const bar = root.querySelector('[data-mf-sticky-bar]');
      if (bar) root._ugMfStickyBarEl = bar;
      return bar;
    }
  
    function ugMfGetStickyBarSlot(root) {
      if (!root) return null;
      if (root._ugMfStickyBarSlot) return root._ugMfStickyBarSlot;
      const slot = root.querySelector('[data-mf-sticky-bar-slot]');
      if (slot) root._ugMfStickyBarSlot = slot;
      return slot;
    }

    /**
     * @param {() => void} callback
     */
    function ugMfPreserveScrollDuringStickyMutation(callback) {
      const savedX = window.scrollX || window.pageXOffset || 0;
      const savedY = window.scrollY || window.pageYOffset || 0;

      const restore = () => {
        const currentY = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(currentY - savedY) > 8) {
          window.scrollTo(savedX, savedY);
        }
      };

      try {
        callback();
      } finally {
        restore();
        requestAnimationFrame(restore);
      }
    }
  
    function ugMfStickyBarMountToFooter(bar, footer, root) {
      if (!bar || !footer || !footer.parentNode || bar.dataset.mfStickyDocked === '1') return;
  
      ugMfPreserveScrollDuringStickyMutation(() => {
        delete bar.dataset.mfStickyPortal;
        footer.parentNode.insertBefore(bar, footer);
        bar.dataset.mfStickyDocked = '1';
        bar.classList.add('ug-mf-sticky-bar--in-flow');
        bar.style.removeProperty('bottom');
        if (root) root.classList.add('ug-mf--sticky-bar-in-flow');
      });
    }
  
    function ugMfStickyBarUnmountToSlot(bar, slot, root) {
      if (!bar || !slot || !slot.parentNode) return;
  
      ugMfPreserveScrollDuringStickyMutation(() => {
        bar.classList.remove('ug-mf-sticky-bar--in-flow');
        delete bar.dataset.mfStickyDocked;
        delete bar.dataset.mfStickyPortal;
        bar.style.removeProperty('bottom');
        if (root) root.classList.remove('ug-mf--sticky-bar-in-flow');
    
        if (bar.parentNode !== slot) {
          slot.appendChild(bar);
        }
      });
    }
  
    /** fixed 模式挂到 body，避免 section / pin-spacer 的 transform 影响 position:fixed */
    function ugMfStickyBarEnsureFixedOnBody(bar) {
      if (!bar || !bar.classList.contains('is-visible') || bar.dataset.mfStickyDocked === '1') {
        return;
      }
  
      if (bar.parentNode !== document.body) {
        document.body.appendChild(bar);
        bar.dataset.mfStickyPortal = '1';
      }
    }
  
    function ugMfSetStickyBarVisible(root, visible) {
      if (!root) return;
  
      const bar = ugMfGetStickyBar(root);
      const slot = ugMfGetStickyBarSlot(root);
      if (!bar) return;
  
      if (visible) {
        bar.classList.add('is-visible');
        root.classList.add('ug-mf--sticky-bar-visible');
      } else {
        bar.classList.remove('is-visible');
        root.classList.remove('ug-mf--sticky-bar-visible');
        if (slot) {
          ugMfStickyBarUnmountToSlot(bar, slot, root);
        }
      }
  
      ugMfSyncStickyBarFlow(root);
    }
  
    /** 滚完 banner 手动段后才显示吸底 bar */
    function ugMfUpdateStickyBarVisibility(root) {
      if (!ugMfGetStickyBar(root)) return;
      ugMfSetStickyBarVisible(root, ugMfIsBannerScrollComplete(root));
    }
  
    function ugMfSyncStickyBarFlow(root) {
      const bar = ugMfGetStickyBar(root);
      const slot = ugMfGetStickyBarSlot(root);
      if (!bar || !slot) return;
  
      if (!bar.classList.contains('is-visible')) {
        ugMfStickyBarUnmountToSlot(bar, slot, root);
        return;
      }
  
      const footer = ugMfFindFooterEl();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!footer || vh <= 0) {
        if (bar.dataset.mfStickyDocked === '1') {
          ugMfStickyBarUnmountToSlot(bar, slot, root);
        }
        ugMfStickyBarEnsureFixedOnBody(bar);
        return;
      }
  
      const fr = footer.getBoundingClientRect();
      const dockToFooter = fr.top < vh && fr.bottom > 0;
  
      if (dockToFooter) {
        ugMfStickyBarMountToFooter(bar, footer, root);
        return;
      }
  
      if (bar.dataset.mfStickyDocked === '1') {
        ugMfStickyBarUnmountToSlot(bar, slot, root);
      }
      ugMfStickyBarEnsureFixedOnBody(bar);
    }
  
    function ugMfScrollToSectionAnchor(root, hash) {
      if (!hash || hash === '#') return false;
      const target = document.querySelector(hash);
      if (!target) return false;
  
      const subnav = root && root.querySelector('[data-mf-subnav]');
      const offset = ugMfGetHeaderOffset(root) + (subnav ? subnav.offsetHeight : 0);
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
  
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  
      const emailInput = target.querySelector(
        '.ug-mf-giveaway__input-email, input[type="email"]'
      );
      if (emailInput) {
        window.setTimeout(() => {
          try {
            emailInput.focus({ preventScroll: true });
          } catch (e) {
            emailInput.focus();
          }
        }, 450);
      }
  
      return true;
    }
  
    function ugMfBindStickyBarScroll(root) {
      const bar = ugMfGetStickyBar(root);
      if (!bar) return;
  
      bar.querySelectorAll('[data-mf-sticky-scroll], a.ug-mf-sticky-bar__btn[href^="#"]').forEach(
        (btn) => {
          if (btn._ugMfStickyScrollBound) return;
          btn._ugMfStickyScrollBound = true;
  
          btn.addEventListener('click', (ev) => {
            const href = btn.getAttribute('href');
            if (!href || href.charAt(0) !== '#') return;
            if (!ugMfScrollToSectionAnchor(root, href)) return;
            ev.preventDefault();
          });
        }
      );
    }
  
    function ugMfInitStickyBar(root) {
      if (!root) return;
  
      const bar = ugMfGetStickyBar(root);
      const slot = ugMfGetStickyBarSlot(root);
      if (!bar || !slot) {
        root.classList.remove('ug-mf--has-sticky-bar', 'ug-mf--sticky-bar-in-flow');
        return;
      }
  
      root.classList.add('ug-mf--has-sticky-bar');
  
      ugMfBindStickyBarScroll(root);
      ugMfEnsureScrollSync(root);
      ugMfUpdateStickyBarVisibility(root);
      ugMfSyncStickyBarFlow(root);
    }
  
    function ugMfKillStickyBar(root) {
      if (!root) return;
  
      const bar = ugMfGetStickyBar(root);
      const slot = ugMfGetStickyBarSlot(root);
  
      ugMfKillScrollSync(root);
  
      if (root._ugMfStickyBarGate) {
        window.removeEventListener('scroll', root._ugMfStickyBarGate);
        root._ugMfStickyBarGate = null;
      }
  
      if (bar && slot) {
        ugMfStickyBarUnmountToSlot(bar, slot, root);
      }
  
      if (bar) {
        bar.classList.remove('is-visible');
      }
  
      root.classList.remove(
        'ug-mf--has-sticky-bar',
        'ug-mf--sticky-bar-visible',
        'ug-mf--sticky-bar-in-flow'
      );
      ugMfFindFooterEl.cached = null;
      root._ugMfStickyBarEl = null;
      root._ugMfStickyBarSlot = null;
    }
  
    let ugMfGleamWidgetPromise = null;
  
    function ugMfGetSectionScope(root) {
      if (!root) return document;
      return root.closest('.shopify-section') || root.parentElement || document;
    }
  
    function ugMfResolveGiveawayFormId(form, root) {
      if (!form) return '';
  
      const direct = String(form.getAttribute('data-id') || form.getAttribute('data-mf-form-api-id') || '').trim();
      if (direct) return direct;
  
      const giveaway = form.closest('[data-mf-giveaway]');
      if (giveaway) {
        const fromGiveaway = String(giveaway.getAttribute('data-mf-form-api-id') || '').trim();
        if (fromGiveaway) return fromGiveaway;
      }
  
      if (root) {
        const fromRoot = String(root.getAttribute('data-mf-form-api-id') || '').trim();
        if (fromRoot) return fromRoot;
      }
  
      return '';
    }
  
    function ugMfFindGleamPopup(root, bid) {
      if (!root || bid == null || String(bid) === '') return null;
  
      const bidStr = String(bid);
      return (
        root.querySelector('.ug-gleam-popup-gleamdiv--' + bidStr) ||
        ugMfGetSectionScope(root).querySelector('.ug-gleam-popup-gleamdiv--' + bidStr)
      );
    }
  
    function ugMfParseTimelineDate(str) {
      if (!str) return null;
      const parts = String(str).trim().split('-');
      if (parts.length !== 3) return null;
      const y = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const d = parseInt(parts[2], 10);
      if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return null;
      const date = new Date(y, m, d);
      date.setHours(0, 0, 0, 0);
      return date;
    }
  
    function ugMfSyncGiveawayTimelineHeight(timeline) {
      if (!timeline) return;
  
      const labels = Array.from(timeline.querySelectorAll('.ug-mf-giveaway__timeline-label'));
      timeline.style.removeProperty('--ug-mf-timeline-label-height');
      if (!labels.length || !ugMfIsMobile()) return;
  
      let maxHeight = 0;
      labels.forEach((label) => {
        maxHeight = Math.max(maxHeight, label.scrollHeight || 0);
      });
  
      if (maxHeight > 0) {
        timeline.style.setProperty('--ug-mf-timeline-label-height', Math.ceil(maxHeight) + 'px');
      }
    }
  
    function ugMfInitGiveawayTimeline(section) {
      const timeline = section.querySelector('[data-mf-giveaway-timeline]');
      if (!timeline) return;
  
      const items = Array.from(timeline.querySelectorAll('[data-mf-timeline-item]'));
      if (!items.length) return;
  
      ugMfSyncGiveawayTimelineHeight(timeline);
  
      const dates = items.map((item) =>
        ugMfParseTimelineDate(item.getAttribute('data-timeline-date'))
      );
  
      const today = new Date();
      today.setHours(0, 0, 0, 0);
  
      let activeIndex = -1;
      dates.forEach((date, index) => {
        if (!date) return;
        if (date.getTime() <= today.getTime()) activeIndex = index;
      });
  
      items.forEach((item, index) => {
        item.classList.toggle('is-active', activeIndex >= 0 && index <= activeIndex);
      });
  
      if (!timeline._ugMfTimelineHeightResize) {
        timeline._ugMfTimelineHeightResize = ugMfDebounce(() => {
          ugMfSyncMobileState();
          ugMfSyncGiveawayTimelineHeight(timeline);
        }, 150);
        window.addEventListener('resize', timeline._ugMfTimelineHeightResize, { passive: true });
      }
  
    }
  
    function ugMfGiveawayEmailOk(value) {
      const s = String(value || '').trim();
      if (!s) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
    }
  
    function ugMfEnsureGleamWidgetLoaded() {
      if (ugMfGleamWidgetPromise) return ugMfGleamWidgetPromise;
  
      ugMfGleamWidgetPromise = new Promise((resolve, reject) => {
        const existing =
          document.querySelector('script[data-ug-mf-gleam-widget="1"]') ||
          document.querySelector('script[src*="widget.gleamjs.io/e.js"]');
  
        if (existing) {
          if (existing.getAttribute('data-loaded') === '1') {
            resolve();
            return;
          }
          existing.addEventListener(
            'load',
            () => {
              existing.setAttribute('data-loaded', '1');
              resolve();
            },
            { once: true }
          );
          existing.addEventListener('error', reject, { once: true });
          return;
        }
  
        const script = document.createElement('script');
        script.src = 'https://widget.gleamjs.io/e.js';
        script.async = true;
        script.setAttribute('data-ug-mf-gleam-widget', '1');
        script.addEventListener(
          'load',
          () => {
            script.setAttribute('data-loaded', '1');
            resolve();
          },
          { once: true }
        );
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });
  
      return ugMfGleamWidgetPromise;
    }
  
    function ugMfOpenGleamPopup(root, bid) {
      if (!root || bid == null || String(bid) === '') return;
  
      const gleamDiv = ugMfFindGleamPopup(root, bid);
      if (!gleamDiv) return;
  
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      gleamDiv.classList.remove('dpn');
  
      ugMfEnsureGleamWidgetLoaded()
        .then(() => {
          window.dispatchEvent(new Event('resize'));
        })
        .catch(() => {});
    }
  
    function ugMfCloseGleamPopup(root, bid) {
      if (!root || bid == null || String(bid) === '') return;
  
      const gleamDiv = ugMfFindGleamPopup(root, bid);
      if (!gleamDiv) return;
  
      gleamDiv.classList.add('dpn');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  
    function ugMfBindGleamPopups(root) {
      if (!root) return;
  
      root.querySelectorAll('.ug-gleam-popup-gleamdiv').forEach((popup) => {
        const className = Array.from(popup.classList).find((cls) =>
          cls.startsWith('ug-gleam-popup-gleamdiv--')
        );
        if (!className) return;
  
        const bid = className.replace('ug-gleam-popup-gleamdiv--', '');
        popup.querySelectorAll('.ug-gleam-popup-gleam-closeFn--' + bid).forEach((el) => {
          if (el._ugMfGleamBound) return;
          el._ugMfGleamBound = true;
          el.addEventListener('click', () => {
            ugMfCloseGleamPopup(root, bid);
          });
        });
      });
    }
  
    function ugMfKillGiveawayProductScroll(root) {
      if (!root) return;
  
      if (root._ugMfGiveawayProductResize) {
        window.removeEventListener('resize', root._ugMfGiveawayProductResize);
        root._ugMfGiveawayProductResize = null;
      }
  
      (root._ugMfGiveawayProductAnimations || []).forEach((entry) => {
        if (entry.tween) entry.tween.kill();
        if (entry.observer) entry.observer.disconnect();
        if (entry.onScroll) window.removeEventListener('scroll', entry.onScroll);
        if (entry.product && window.gsap) {
          entry.product.classList.remove('is-gsap-ready');
          entry.product._ugMfGaPlayed = false;
          window.gsap.set(entry.product, {
            clearProps:
              'transform,left,right,bottom,top,x,y,xPercent,yPercent,width',
          });
          if (entry.target && entry.target !== entry.product) {
            window.gsap.set(entry.target, {
              clearProps:
                'transform,left,right,bottom,top,x,y,xPercent,yPercent,width',
            });
          }
        }
      });
      root._ugMfGiveawayProductAnimations = null;
      root._ugMfGiveawayProductWasMobile = null;
    }
  
    function ugMfGetGiveawayProductRise(product) {
      const isMobile = ugMfIsMobile();
      const media = product.querySelector(
        isMobile
          ? '.ug-mf-giveaway__product-media--mb'
          : '.ug-mf-giveaway__product-media--pc'
      );
      const img = media ? media.querySelector('.ug-mf-giveaway__product-img') : null;
  
      if (img) {
        const height = img.getBoundingClientRect().height || img.offsetHeight;
        if (height > 0) return height;
      }
  
      return isMobile ? 236 : 382;
    }
  
    function ugMfBindOneGiveawayProductScroll(root, product) {
      const gsap = window.gsap;
      const card = product.closest('.ug-mf-giveaway__card');
      if (!card || !gsap) return null;

      const isMobile = ugMfIsMobile();
      const media = product.querySelector(
        isMobile
          ? '.ug-mf-giveaway__product-media--mb'
          : '.ug-mf-giveaway__product-media--pc'
      );
      const rise = ugMfGetGiveawayProductRise(product);

      product.classList.add('is-gsap-ready');

      let target = product;
      const gsapClear =
        'transform,left,right,bottom,top,x,y,xPercent,yPercent,width';

      if (isMobile && media) {
        gsap.set(product, { clearProps: gsapClear });
        gsap.set(media, { clearProps: gsapClear });
        target = media;
        gsap.set(target, { y: rise, x: 0, force3D: true });
      } else {
        gsap.set(target, {
          y: rise,
          force3D: true,
        });
      }

      if (ugMfPrefersReducedMotion()) {
        gsap.set(target, { y: 0, x: 0 });
        return null;
      }

      let tween = null;
      let observer = null;
      let onScroll = null;

      const playOnce = () => {
        if (product._ugMfGaPlayed) return;
        product._ugMfGaPlayed = true;
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        if (onScroll) {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          onScroll = null;
        }
        tween = gsap.to(target, {
          y: 0,
          x: 0,
          duration: UG_MF_GA_PRODUCT_DUR,
          ease: 'power2.out',
          overwrite: 'auto',
        });
      };
  
      const checkAndPlay = () => {
        if (product._ugMfGaPlayed) return;
        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const rect = card.getBoundingClientRect();
        if (rect.top <= vh * 0.88 && rect.bottom >= 0) {
          playOnce();
        }
      };
  
      if (typeof IntersectionObserver !== 'undefined') {
        observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            playOnce();
          },
          { root: null, rootMargin: '0px 0px -12% 0px', threshold: 0 }
        );
        observer.observe(card);
      }
  
      onScroll = ugMfRafThrottle(checkAndPlay);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      requestAnimationFrame(checkAndPlay);
  
      return { tween, observer, onScroll, product, target };
    }
  
    function ugMfBindGiveawayProductScroll(root) {
      if (!root || !root.querySelector('[data-mf-giveaway-product]')) return;
  
      const gsap = window.gsap;
      if (!gsap) return;
  
      ugMfKillGiveawayProductScroll(root);
      ugMfEnsureGsapRegistered();
  
      const animations = [];
  
      root.querySelectorAll('[data-mf-giveaway-product]').forEach((product) => {
        const entry = ugMfBindOneGiveawayProductScroll(root, product);
        if (entry) animations.push(entry);
      });
  
      root._ugMfGiveawayProductAnimations = animations;
      root._ugMfGiveawayProductWasMobile = ugMfIsMobile();
      root._ugMfGiveawayProductResize = ugMfDebounce(() => {
        ugMfSyncMobileState();
        const nowMobile = ugMfIsMobile();
        if (nowMobile !== root._ugMfGiveawayProductWasMobile) {
          root._ugMfGiveawayProductWasMobile = nowMobile;
          ugMfBindGiveawayProductScroll(root);
        }
      }, 150);
      window.addEventListener('resize', root._ugMfGiveawayProductResize, { passive: true });
    }
  
    function ugMfBindGiveawayForms(root) {
      if (!root) return;
  
      const endpoint = 'https://ecf.cirkleinc.com/api/form-submit';
  
      root.querySelectorAll('.ug-mf-giveaway-form').forEach(function (form) {
        if (form._ugMfGiveawayFormBound) return;
        form._ugMfGiveawayFormBound = true;
  
        const email = form.querySelector('.ug-mf-giveaway__input-email');
        const checkbox = form.querySelector('.ug-mf-giveaway__checkbox');
        const messageEl = form.querySelector('.ug-mf-giveaway__form-msg .message');
        const errorEl = form.querySelector('.ug-mf-giveaway__form-msg .error');
  
        function clearGiveawayMsgs() {
          if (messageEl) messageEl.textContent = '';
          if (errorEl) errorEl.textContent = '';
        }
  
        if (email) email.addEventListener('input', clearGiveawayMsgs);
        if (checkbox) checkbox.addEventListener('change', clearGiveawayMsgs);
  
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const submitBtn = form.querySelector('.ug-mf-giveaway__submit');
          const emailField = form.querySelector('.ug-mf-giveaway__input-email');
          const termsBox = form.querySelector('.ug-mf-giveaway__checkbox');
          const msgEl = form.querySelector('.ug-mf-giveaway__form-msg .message');
          const errEl = form.querySelector('.ug-mf-giveaway__form-msg .error');
          const formId = ugMfResolveGiveawayFormId(form, root);
          const gleamBid = form.getAttribute('data-gleam-bid');
          const msgOk = form.getAttribute('data-success') || '';
          const errEmail = form.getAttribute('data-email-error') || '';
          const errEmailFmt = form.getAttribute('data-email-invalid') || '';
          const errTerms = form.getAttribute('data-terms-error') || '';
  
          if (msgEl) msgEl.textContent = '';
          if (errEl) errEl.textContent = '';
  
          const raw = emailField && emailField.value ? String(emailField.value).trim() : '';
  
          if (!raw) {
            if (errEl) errEl.textContent = errEmail || 'Please enter your email.';
            return;
          }
          if (!ugMfGiveawayEmailOk(raw)) {
            if (errEl) errEl.textContent = errEmailFmt || 'Please enter a valid email address.';
            return;
          }
          if (!termsBox || !termsBox.checked) {
            if (errEl) errEl.textContent = errTerms || 'Please accept the terms.';
            return;
          }
          if (!formId) {
            if (errEl) errEl.textContent = 'Form is not configured (missing API id).';
            return;
          }
          if (submitBtn && submitBtn.classList.contains('loading')) return;
          if (submitBtn) submitBtn.classList.add('loading');
  
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: raw,
              accepts_marketing: termsBox.checked ? 'on' : 'off',
              form_id: formId,
            }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              if (submitBtn) submitBtn.classList.remove('loading');
              const formOk =
                data &&
                (data.status === 'success' ||
                  data.success === true ||
                  String(data.status || '').toLowerCase() === 'success');
  
              if (formOk) {
                if (emailField) emailField.value = '';
                if (errEl) errEl.textContent = '';
                if (msgEl) msgEl.textContent = msgOk || data.message || 'Success';
                if (gleamBid && ugMfFindGleamPopup(root, gleamBid)) {
                  ugMfOpenGleamPopup(root, gleamBid);
                }
              } else {
                const em =
                  (data.errors && data.errors.email && data.errors.email[0]) ||
                  data.message ||
                  'Something went wrong.';
                if (errEl) errEl.textContent = em;
              }
            })
            .catch(function () {
              if (submitBtn) submitBtn.classList.remove('loading');
              if (errEl) errEl.textContent = 'Network error. Please try again.';
            });
        });
      });
    }
  
    function ugMfBindGiveaway(root) {
      if (!root) return;
      root.querySelectorAll('[data-mf-giveaway]').forEach(ugMfInitGiveawayTimeline);
      ugMfBindGiveawayForms(root);
      ugMfBindGleamPopups(root);
      ugMfDeferGiveawayProductScroll(root);
    }
  
    function ugMfDeferGiveawayProductScroll(root) {
      if (!root || !root.querySelector('[data-mf-giveaway-product]')) return;
  
      const run = () => {
        ugMfDeferUntilBannerReady(root, () => {
          ugMfBindGiveawayProductScroll(root);
        });
      };
  
      const section = root.querySelector('[data-mf-giveaway]');
      if (!section || typeof IntersectionObserver === 'undefined') {
        run();
        return;
      }
  
      if (root._ugMfGiveawayIo) {
        root._ugMfGiveawayIo.disconnect();
      }
  
      const io = new IntersectionObserver(
        (entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          root._ugMfGiveawayIo = null;
          run();
        },
        { root: null, rootMargin: '160px 0px', threshold: 0 }
      );
  
      root._ugMfGiveawayIo = io;
      io.observe(section);
    }
  
    function ugMfKillGiveaway(root) {
      if (!root) return;
      ugMfGleamWidgetPromise = null;
  
      root.querySelectorAll('.ug-mf-giveaway-form').forEach((form) => {
        form._ugMfGiveawayFormBound = false;
      });
  
      root.querySelectorAll('[data-mf-giveaway-timeline]').forEach((timeline) => {
        timeline.style.removeProperty('--ug-mf-timeline-label-height');
        if (timeline._ugMfTimelineHeightResize) {
          window.removeEventListener('resize', timeline._ugMfTimelineHeightResize);
          timeline._ugMfTimelineHeightResize = null;
        }
      });
  
      if (root._ugMfGiveawayIo) {
        root._ugMfGiveawayIo.disconnect();
        root._ugMfGiveawayIo = null;
      }
  
      ugMfKillGiveawayProductScroll(root);
    }
  
    function ugMfRunAfterScrollRestore(root, callback) {
      ugMfClearReloadScrollLock();
      if (!ugMfIsReloadNavigation()) {
        callback();
        return;
      }

      try {
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'auto';
        }
      } catch (e) {
        /* ignore */
      }

      requestAnimationFrame(() => {
        ugMfClearReloadScrollLock();
        callback();
      });
    }
  
    function ugMfMount(root) {
      if (!root) return;
      if (root.dataset.mfMounted === '1' || root.dataset.mfMounting === '1') return;
      root.dataset.mfMounting = '1';
      ugMfClearReloadScrollLock();
      ugMfClearStaleInlineThemeVars(root);
      ugMfBannerDebug(root, 'mount start', {
        hasPin: !!root.querySelector('[data-mf-banner-pin]'),
        hasGsap: !!window.gsap,
        hasScrollTrigger: !!window.ScrollTrigger,
      }, true);
  
      try {
        ugMfApplyStickyTop(root);
      } catch (e) {
        /* ignore */
      }
  
      try {
        ugMfSetStickyBarVisible(root, false);
      } catch (e) {
        /* ignore */
      }
  
      ugMfRunAfterScrollRestore(root, () => {
        try {
          const hasBanner = ugMfBindBannerScroll(root);
          ugMfBannerDebug(root, 'mount after bind', { hasBanner }, true);

          if (!hasBanner) {
            ugMfInitStickyBar(root);
            ugMfSetStickyBarVisible(root, true);
            ugMfInitAfterBannerReady(root);
            ugMfInitScrollEffects(root);
          }
        } catch (e) {
          ugMfForceCompleteBannerAuto(root);
          ugMfInitAfterBannerReady(root);
          ugMfInitScrollEffects(root);
        } finally {
          ugMfClearReloadScrollLock();
          root.dataset.mfMounting = '0';
          root.dataset.mfMounted = '1';
        }
      });
    }
  
    function ugMfDeferProductsScroll(root) {
      if (!root || !root.querySelector('[data-mf-products-product]')) return;
  
      const section = root.querySelector('.ug-mf-products');
      if (!section) {
        ugMfBindProductsScroll(root);
        return;
      }
  
      const run = () => {
        ugMfDeferUntilBannerReady(root, () => {
          ugMfBindProductsScroll(root);
        });
      };
  
      if (typeof IntersectionObserver === 'undefined') {
        run();
        return;
      }
  
      if (root._ugMfProductsIo) {
        root._ugMfProductsIo.disconnect();
      }
  
      const io = new IntersectionObserver(
        (entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          root._ugMfProductsIo = null;
          run();
        },
        { root: null, rootMargin: '120px 0px', threshold: 0 }
      );
  
      root._ugMfProductsIo = io;
      io.observe(section);
    }
  
    function ugMfDepsReady() {
      return Boolean(window.gsap && window.ScrollTrigger);
    }
  
    function ugMfRunWhenDepsReady(callback, maxAttempts) {
      const limit = maxAttempts || 40;
      let attempts = 0;
  
      function tick() {
        if (ugMfDepsReady()) {
          callback();
          return;
        }
        attempts += 1;
        if (attempts >= limit) return;
        window.setTimeout(tick, 50);
      }
  
      tick();
    }
  
    window.ugMusicFestival = {
      mount: ugMfMount,
      teardown: ugMfTeardown,
      refreshBanner: ugMfRefreshBannerScroll,
      bindPartnershipCarousels: ugMfBindPartnershipCarousels,
      applyTransparentHeader: ugMfApplyTransparentHeader,
      removeTransparentHeader: ugMfRemoveTransparentHeader,
      runWhenDepsReady: ugMfRunWhenDepsReady,
      depsReady: ugMfDepsReady,
      clearScrollLock: ugMfClearReloadScrollLock,
    };
  
    function ugMfAutoMountExistingSections(reason) {
      const roots = Array.from(document.querySelectorAll('.ug-mf'));
  
      roots.forEach((root) => {
        if (root.dataset.mfMounted === '1') {
          ugMfBannerDebug(root, 'auto mount skip - already mounted', { reason }, true);
          return;
        }

        ugMfBannerDebug(root, 'auto mount root', { reason }, true);
        ugMfMount(root);
      });
    }
  
    ugMfRunWhenDepsReady(() => {
      ugMfAutoMountExistingSections('asset-fallback');
    }, 60);
  })();
  